// // import React, { useEffect, useMemo, useState } from "react";
// // import styled from "styled-components";
// // import NavBarSuper from "./NavBarSuper";
// // import Footer from "./Footer";
// // import api from "../api";
// // import { useParams, useNavigate, useLocation } from "react-router-dom";

// // /* ================= HELPERS ================= */
// // const formatValue = (value, fallback = "—") => {
// //   if (value === null || value === undefined || value === "") return fallback;
// //   return value;
// // };

// // const scoreValue = (value) => {
// //   if (value === null || value === undefined || value === "") return "—";
// //   return value;
// // };

// // const gradeFromScore = (score) => {
// //   const s = Number(score || 0);
// //   if (s >= 90) return "A";
// //   if (s >= 80) return "B";
// //   if (s >= 70) return "C";
// //   if (s >= 60) return "D";
// //   return "E";
// // };

// // const getWeekOfMonth = (dateString) => {
// //   if (!dateString) return "Week 1";
// //   const d = new Date(dateString);
// //   const firstDay = new Date(d.getFullYear(), d.getMonth(), 1).getDay();
// //   return `Week ${Math.ceil((d.getDate() + firstDay) / 7)}`;
// // };

// // const formatNiceDate = (dateString) => {
// //   if (!dateString) return "—";
// //   return new Date(dateString).toDateString();
// // };

// // const getGoalUnit = (goal) => {
// //   return goal.unit || goal.subDepartment || "General Unit";
// // };

// // /* ================= SHARED COMPONENTS ================= */
// // const ExpandableText = ({ text, limit = 90, isWeekly = false }) => {
// //   const [isExpanded, setIsExpanded] = useState(false);
// //   if (!text) return null;

// //   const textStyle = {
// //     maxWidth: "350px",
// //     wordWrap: "break-word",
// //     marginTop: isWeekly ? "4px" : "10px",
// //     fontWeight: isWeekly ? "600" : "700",
// //     color: "#0f172a",
// //     fontSize: isWeekly ? "13px" : "14px",
// //     lineHeight: "1.5",
// //   };

// //   if (String(text).length <= limit) {
// //     return <div style={textStyle}>{text}</div>;
// //   }

// //   return (
// //     <div style={{ ...textStyle, display: "block" }}>
// //       <span style={{ display: "inline" }}>
// //         {isExpanded ? text : `${String(text).substring(0, limit)}...`}
// //       </span>
// //       <button
// //         type="button"
// //         onClick={(e) => {
// //           e.preventDefault();
// //           setIsExpanded(!isExpanded);
// //         }}
// //         style={{
// //           background: "none", border: "none", color: "#2563eb",
// //           cursor: "pointer", fontSize: "12px", fontWeight: "800",
// //           padding: "0 0 0 6px", textDecoration: "underline",
// //         }}
// //       >
// //         {isExpanded ? "Show less" : "Read more"}
// //       </button>
// //     </div>
// //   );
// // };

// // /* ================= LAYOUT STYLES ================= */
// // // Notice the use of $collapsed to prevent DOM warnings
// // const Container = styled.div`
// //   --page-bg: linear-gradient(180deg, #f8fafc 0%, #edf4ff 100%);
// //   min-height: 100vh; background: var(--page-bg); margin-left: 0;
// // `;

// // const Main = styled.main`
// //   width: min(1450px, calc(100% - 32px)); margin: 0 auto; padding: 90px 0 60px;
// //   @media (max-width: 1024px) { width: min(100%, calc(100% - 24px)); padding: 84px 0 40px; }
// //   @media (max-width: 576px) { width: min(100%, calc(100% - 16px)); padding: 80px 0 28px; }
// // `;

// // const TableWrap = styled.div`
// //   overflow-x: auto;
// //   border: 1px solid #e5e7eb;
// //   border-radius: 16px;
// //   margin-bottom: 18px;

// //   @media (max-width: 900px) { display: none; }
// // `;

// // const PageHeader = styled.div`
// //   display: flex; justify-content: space-between; align-items: flex-end;
// //   gap: 16px; flex-wrap: wrap; margin-bottom: 24px;
// // `;

// // const Title = styled.h1`
// //   font-size: clamp(1.6rem, 1.2rem + 1vw, 2.1rem); font-weight: 800; color: #0f172a; margin: 0 0 6px;
// // `;

// // const Subtitle = styled.p`
// //   color: #64748b; font-size: 15px; margin: 0; line-height: 1.6;
// // `;

// // const DocumentCard = styled.div`
// //   background: white; border-radius: 24px; padding: 24px;
// //   box-shadow: 0 22px 55px rgba(15, 23, 42, 0.08); border: 1px solid #e8eef7;
// //   @media (max-width: 576px) { padding: 16px; border-radius: 20px; }
// // `;

// // const DocumentTop = styled.div`
// //   border-bottom: 2px solid #e2e8f0; padding-bottom: 18px; margin-bottom: 22px;
// // `;

// // const DocTitle = styled.h2`
// //   font-size: clamp(1.3rem, 1.1rem + 0.6vw, 1.7rem); font-weight: 800; color: #0f172a; margin: 0 0 10px;
// // `;

// // const PeriodRow = styled.div`
// //   display: flex; flex-wrap: wrap; gap: 12px;
// // `;

// // const Pill = styled.div`
// //   display: inline-flex; align-items: center; padding: 8px 12px;
// //   background: ${(props) => props.bg || "#eff6ff"};
// //   color: ${(props) => props.color || "#1d4ed8"};
// //   border-radius: 999px; font-size: 13px; font-weight: 700;
// // `;

// // const SectionBlock = styled.section`
// //   margin-top: 28px;
// // `;

// // const SectionHeading = styled.div`
// //   background: linear-gradient(135deg, #0f172a, #1d4ed8);
// //   color: white; border-radius: 16px; padding: 14px 18px; margin-bottom: 16px;
// // `;

// // const SectionTitle = styled.h3`
// //   font-size: 18px; font-weight: 800; margin: 0 0 4px;
// // `;

// // const SectionSub = styled.p`
// //   font-size: 13px; margin: 0; opacity: 0.9;
// // `;

// // const NoticeBox = styled.div`
// //   border: 1px solid #dbeafe; background: #f8fbff; color: #334155;
// //   border-radius: 14px; padding: 16px; margin-bottom: 18px;
// //   line-height: 1.6; font-size: 14px;
// // `;

// // const SectionHeader = styled.div`
// //   margin-bottom: 18px;
// // `;

// // const SecTitle = styled.h2`
// //   margin: 0; font-size: clamp(1.2rem, 1rem + 0.7vw, 1.7rem); font-weight: 800;
// // `;

// // const TableWrapper = styled.div`
// //   width: 100%; overflow-x: auto; border-radius: 12px;
// //   border: 1px solid rgba(148, 163, 184, 0.14); margin-bottom: 24px;
// //   @media (max-width: 1024px) { display: none; }
// // `;

// // const Table = styled.table`
// //   width: 100%; border-collapse: collapse; background: white; table-layout: fixed;
// // `;

// // const Th = styled.th`
// //   background: #fef2f2; padding: 12px 10px; text-align: left;
// //   font-size: 12px; font-weight: 800; color: #7f1d1d;
// //   border-bottom: 2px solid #e2e8f0; border-right: 1px solid #e2e8f0; border-left: 1px solid #e2e8f0;
// //   vertical-align: middle; line-height: 1.3;
// //   &:first-child { border-left: none; }
// //   &:last-child { border-right: none; }
// // `;

// // const Td = styled.td`
// //   padding: 10px 8px; border-bottom: 1px solid #e2e8f0; border-right: 1px solid #e2e8f0;
// //   border-left: 1px solid #e2e8f0; vertical-align: top;
// //   font-size: 13px; color: #1e293b; white-space: normal; word-break: break-word;
// //   overflow-wrap: anywhere; line-height: 1.4;
// //   &:first-child { border-left: none; }
// //   &:last-child { border-right: none; }
// // `;

// // const MonthlyHeader = styled.div`
// //   background: #fef2f2; padding: 12px 14px; border-left: 4px solid #ef4444; border-radius: 8px; height: 100%; box-sizing: border-box;
// // `;

// // const RoutineHeader = styled(MonthlyHeader)`
// //   background: #fff7ed; border-left-color: #ea580c;
// // `;

// // const WeekGoalBox = styled.div`
// //   padding: 12px; border-left: 3px solid #ef4444; background: #fdf2f2; border-radius: 6px; font-size: 12px; color: #334155; word-wrap: break-word; height: 100%; box-sizing: border-box;
// // `;

// // const WeekAchBox = styled.div`
// //   padding: 12px; border-left: 3px solid #16a34a; background: #f0fdf4; border-radius: 6px; font-size: 12px; color: #334155; line-height: 1.5; word-break: break-word; height: 100%; box-sizing: border-box;
// // `;

// // const GoalDate = styled.div`
// //   font-size: 11px; margin-top: 7px; color: #64748b;
// // `;

// // const UnitBadge = styled.span`
// //   display: inline-block; margin-top: 6px; padding: 4px 10px; background: #e0f2fe; color: #0369a1; border: 1px solid #bae6fd; border-radius: 6px; font-size: 11px; font-weight: 800; letter-spacing: 0.05em; text-transform: uppercase;
// // `;

// // const CommentLabel = styled.div`
// //   font-size: 10px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em;
// //   color: ${({ $color }) => $color || "#64748b"}; margin-bottom: 4px; margin-top: ${({ $marginTop }) => $marginTop || "0"};
// // `;
// // const MobileDate = styled.div`
// //   font-size: 12px;
// //   color: #64748b;
// // `;
// // /* Mobile Styles */
// // const MobileGrid = styled.div`
// //   display: none;
// //   @media (max-width: 1024px) { display: grid; gap: 16px; margin-bottom: 24px; }
// // `;

// // const MobileCard = styled.div`
// //   background: white; border: 1px solid rgba(148, 163, 184, 0.14);
// //   border-left: 5px solid ${({ $isRoutine }) => ($isRoutine ? "#ea580c" : "#ef4444")};
// //   border-radius: 16px; padding: 16px; box-shadow: 0 4px 16px rgba(15, 23, 42, 0.05); display: flex; flex-direction: column; min-width: 0;
// // `;

// // const MobileTop = styled.div`
// //   display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 8px;
// // `;

// // const MobilePill = styled.div`
// //   display: inline-flex; align-items: center; padding: 4px 10px; border-radius: 999px; font-size: 11px; font-weight: 800; letter-spacing: 0.04em; text-transform: uppercase;
// //   background: ${({ $isRoutine }) => $isRoutine ? "rgba(234,88,12,0.12)" : "rgba(220, 38, 38, 0.12)"};
// //   color: ${({ $isRoutine }) => ($isRoutine ? "#c2410c" : "#b91c1c")};
// // `;

// // const MobileTitle = styled.div`
// //   font-size: 14px; font-weight: 800; color: #0f172a; line-height: 1.4; margin-bottom: 4px; word-wrap: break-word; overflow-wrap: anywhere;
// // `;

// // const MobileLabel = styled.div`
// //   font-size: 11px; font-weight: 800; margin-top: 16px; margin-bottom: 6px; color: #64748b; text-transform: uppercase; letter-spacing: 0.04em;
// // `;

// // const DisabledInput = styled.div`
// //   min-height: 42px; border: 1px solid #e2e8f0; background: #f8fafc; color: #334155; border-radius: 10px; padding: 10px 12px; line-height: 1.5; white-space: pre-wrap;
// // `;

// // const SmallScore = styled.div`
// //   width: 46px; min-height: 42px; display: inline-flex; align-items: center; justify-content: center; border-radius: 10px; border: 1px solid #dbe3ee; background: ${(props) => (props.muted ? "#f8fafc" : "#eef2ff")}; font-weight: 800; color: #0f172a;
// // `;

// // const ScoreList = styled.div`
// //   display: grid; gap: 10px;
// // `;

// // const EditableScore = styled.input`
// //   width: 100%; max-width: 60px; padding: 6px 4px; text-align: center; border: 1px solid #2563eb; border-radius: 8px; font-weight: 700; font-size: 14px; outline: none;
// // `;

// // const EditableText = styled.textarea`
// //   width: 100%; min-height: 72px; border: 1px solid #2563eb; border-radius: 10px; padding: 10px 12px; font-size: 13px; resize: vertical; outline: none;
// // `;

// // const LegacyTable = styled.table`
// //   width: 100%; min-width: 1200px; border-collapse: collapse;
// //   th, td { border-bottom: 1px solid #e5e7eb; vertical-align: top; padding: 12px; text-align: left; font-size: 14px; }
// //   thead th { background: #f8fafc; color: #0f172a; font-weight: 800; white-space: nowrap; }
// // `;

// // const SummaryGrid = styled.div`
// //   display: grid; grid-template-columns: 1.2fr 1fr; gap: 18px;
// //   @media (max-width: 980px) { grid-template-columns: 1fr; }
// // `;

// // const SummaryCard = styled.div`
// //   border: 1px solid #e5e7eb; border-radius: 16px; padding: 18px; background: white;
// // `;

// // const CardTitle = styled.h4`
// //   margin: 0 0 14px; font-size: 16px; color: #0f172a;
// // `;

// // const ScoreRow = styled.div`
// //   display: flex; justify-content: space-between; gap: 12px; padding: 12px 0; border-bottom: 1px solid #eef2f7; font-size: 14px;
// // `;

// // const BigGrade = styled.div`
// //   font-size: clamp(2rem, 1.8rem + 1vw, 2.6rem); font-weight: 900; color: #1d4ed8;
// // `;

// // const TextBlock = styled.div`
// //   min-height: 110px; border: 1px solid #e2e8f0; border-radius: 14px; background: #f8fafc; padding: 14px; white-space: pre-wrap; line-height: 1.7; color: #334155;
// // `;

// // const SaveButton = styled.button`
// //   background: linear-gradient(135deg, #16a34a, #22c55e); color: white; border: none; padding: 14px 32px; border-radius: 12px; font-weight: 700; font-size: 1.05rem; cursor: pointer; margin: 30px 0 10px; transition: all 0.2s;
// //   &:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 10px 20px rgba(22, 163, 74, 0.3); }
// //   &:disabled { background: #94a3b8; cursor: not-allowed; }
// // `;

// // const InfoMessage = styled.div`
// //   text-align: center; padding: 90px 20px; color: #64748b; background: white; border-radius: 20px; border: 1px dashed #cbd5e1;
// // `;
// // //others
// // /* ================= MAIN COMPONENT ================= */
// // const SupervisorAppraisalForm = ({ user }) => {
// //   const [collapsed, setCollapsed] = useState(false);
// //   const { appraisalId } = useParams();
// //   const navigate = useNavigate();
// //   const location = useLocation();

// //   const [appraisal, setAppraisal] = useState(null);
// //   const [goals, setGoals] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [saving, setSaving] = useState(false);
// //   const [error, setError] = useState(null);
// //   const [success, setSuccess] = useState("");

// //   const [editedData, setEditedData] = useState({
// //     section2: [],
// //     section3: [],
// //     section4: [],
// //     summary: {},
// //     staffFeedback: {},
// //   });

// //   useEffect(() => {
// //     const fetchData = async () => {
// //       try {
// //         setLoading(true);
// //         setError(null);

// //         // 1. Fetch the appraisal
// //         const appRes = await api.get(`/appraisal/${appraisalId}`);
// //         const appraisalData = appRes.data?.appraisal || appRes.data?.data || appRes.data || {};
        
// //         // 2. Identify the Staff ID
// //         // Try the router state first
// //         let staffId = location.state?.staffId;

// //         // Fallback if state is empty (e.g., page refresh)
// //         if (!staffId) {
// //             let rawStaffId = appraisalData.userId || appraisalData.userDetails || appraisalData.user || appraisalData.staffId;
// //             if (rawStaffId) {
// //                 if (typeof rawStaffId === "string") {
// //                     staffId = rawStaffId;
// //                 } else if (typeof rawStaffId === "object") {
// //                     staffId = rawStaffId._id || rawStaffId.id || rawStaffId.$oid || "";
// //                 }
// //             }
// //         }

// //         // Force it to be a clean string
// //         staffId = String(staffId).trim();

// //         // Final Safety Net
// //         if (!staffId || staffId === "[object Object]" || staffId === "undefined") {
// //             console.error("CRITICAL ERROR: Could not find the Staff ID! Raw data:", appraisalData);
// //             throw new Error("Cannot load goals: Staff ID is missing.");
// //         }

// //         // 3. Fetch goals using the clean ID
// //         const goalsRes = await api.get(`/goals/staff-current-month/${staffId}`);
// //         const currentGoals = goalsRes.data?.data || [];
// //         const responseMonth = goalsRes.data?.month || "";

// //         setAppraisal(appraisalData);
// //         setGoals(currentGoals);

// //         // Build merged section2 with live goals + supervisor data
// //         const mergedSection2 = buildMergedSection2(appraisalData, currentGoals, responseMonth);

// //         setEditedData({
// //           section2: mergedSection2,
// //           section3: appraisalData.section3 || [],
// //           section4: appraisalData.section4 || [],
// //           summary: appraisalData.summary || {},
// //           staffFeedback: appraisalData.staffFeedback || {},
// //         });
// //       } catch (err) {
// //         console.error(err);
// //         setError(err.response?.data?.message || err.message || "Failed to load data");
// //       } finally {
// //         setLoading(false);
// //       }
// //     };

// //     if (appraisalId) fetchData();
// //   }, [appraisalId, location.state]);

// //   const buildMergedSection2 = (appraisalData, currentGoals, responseMonth) => {
// //     if (!currentGoals || currentGoals.length === 0) {
// //       console.warn("⚠️ No goals returned from backend for this staff member");
// //     }

// //     const existingSection2 = appraisalData.section2 || [];
// //     const existingMonth = existingSection2[0] || {};

// //     const monthlyGoals = currentGoals.filter(g => g.type === "monthly");
// //     const routineGoals = currentGoals.filter(g => g.type === "routine");

// //     const majorGoals = monthlyGoals.map((liveGoal) => {
// //       // Find matching saved appraisal snapshot
// //       const saved = existingSection2.flatMap(m => m.majorGoals || [])
// //         .find(s => String(s.goal) === String(liveGoal.goal) || String(s.goalId) === String(liveGoal._id)) || {};

// //       // Match live weekly goals strictly by String ID
// //       const liveWeeks = currentGoals
// //         .filter(w => w.type === "weekly" && String(w.parentMonthlyGoal) === String(liveGoal._id))
// //         .sort((a, b) => new Date(a.weeklyDeliveryDate || 0) - new Date(b.weeklyDeliveryDate || 0));
      
// //       let weekly = [];
// //       if (liveWeeks.length > 0) {
// //           weekly = liveWeeks.map((w) => ({
// //             week: getWeekOfMonth(w.weeklyDeliveryDate),
// //             weeklyGoal: w.goal || "",
// //             weeklyAchievement: w.achievements || "",
// //             weeklyComment: w.comments || "",
// //             weeklyDeliveryDate: w.weeklyDeliveryDate,
// //           }));
// //       } else if (saved.weekly && saved.weekly.length > 0) {
// //           weekly = saved.weekly; // Fallback to what's inside the appraisal DB
// //       }

// //       return {
// //         goalId: liveGoal._id,
// //         goal: liveGoal.goal || "",
// //         unit: getGoalUnit(liveGoal),
// //         startDate: liveGoal.startDate,
// //         deliveryDate: liveGoal.deliveryDate,
// //         // Priority: Saved Appraisal Snapshot -> Live Goal Data -> Empty
// //         achievement: saved.achievement || liveGoal.monthlyAchievements || liveGoal.achievements || "",
// //         staffComment: saved.staffComment || liveGoal.monthlyComments || liveGoal.comments || saved.comments || "",
// //         staffActionScore: saved.staffActionScore ?? "",
// //         staffQualityScore: saved.staffQualityScore ?? "",
// //         supervisorActionScore: saved.supervisorActionScore ?? "",
// //         supervisorQualityScore: saved.supervisorQualityScore ?? "",
// //         supervisorComments: saved.supervisorComments || "",
// //         weekly,
// //       };
// //     });

// //     const otherGoals = routineGoals.map((liveGoal) => {
// //       const saved = existingSection2.flatMap(m => m.otherGoals || [])
// //         .find(s => String(s.goal) === String(liveGoal.goal) || String(s.goalId) === String(liveGoal._id)) || {};

// //       return {
// //         goalId: liveGoal._id,
// //         goal: liveGoal.goal || "",
// //         unit: getGoalUnit(liveGoal),
// //         deliveryDate: liveGoal.deliveryDate,
// //         achievement: saved.achievement || liveGoal.achievements || "",
// //         staffComment: saved.staffComment || liveGoal.comments || saved.comments || "",
// //         staffActionScore: saved.staffActionScore ?? "",
// //         staffQualityScore: saved.staffQualityScore ?? "",
// //         supervisorActionScore: saved.supervisorActionScore ?? "",
// //         supervisorQualityScore: saved.supervisorQualityScore ?? "",
// //         supervisorComments: saved.supervisorComments || "",
// //       };
// //     });

// //     return [{
// //       month: responseMonth || existingMonth.month || appraisalData.appraisalPeriod || "Current Month",
// //       majorGoals,
// //       otherGoals,
// //     }];
// //   };

// //   const monthData = useMemo(() => editedData.section2 || [], [editedData.section2]);

// //   /* ================= CALCULATIONS ================= */
// //   const section2SupervisorTotal = useMemo(() => {
// //     return (editedData.section2 || []).reduce((acc, month) => {
// //       const majorValid = (month.majorGoals || []).filter(g =>
// //         !isNaN(Number(g.supervisorActionScore)) && !isNaN(Number(g.supervisorQualityScore))
// //       );
// //       const otherValid = (month.otherGoals || []).filter(g =>
// //         !isNaN(Number(g.supervisorActionScore)) && !isNaN(Number(g.supervisorQualityScore))
// //       );

// //       const majorSum = majorValid.reduce((sum, g) =>
// //         sum + ((Number(g.supervisorActionScore) + Number(g.supervisorQualityScore)) / 2), 0
// //       );
// //       const otherSum = otherValid.reduce((sum, g) =>
// //         sum + ((Number(g.supervisorActionScore) + Number(g.supervisorQualityScore)) / 2), 0
// //       );

// //       const majorTotal = majorValid.length ? ((majorSum / majorValid.length) / 5) * 55 : 0;
// //       const otherTotal = otherValid.length ? ((otherSum / otherValid.length) / 5) * 15 : 0;

// //       return acc + majorTotal + otherTotal;
// //     }, 0);
// //   }, [editedData.section2]);

// //   const section3SupervisorTotal = useMemo(() => {
// //     const items = editedData.section3 || [];
// //     const valid = items.filter(x => !isNaN(Number(x.supervisorScore)));
// //     const sum = valid.reduce((acc, item) => acc + Number(item.supervisorScore), 0);
// //     return valid.length ? (sum / valid.length / 5) * 20 : 0;
// //   }, [editedData.section3]);

// //   const section4SupervisorTotal = useMemo(() => {
// //     const items = editedData.section4 || [];
// //     const valid = items.filter(x => !isNaN(Number(x.supervisorScore)));
// //     const sum = valid.reduce((acc, item) => acc + Number(item.supervisorScore), 0);
// //     return valid.length ? (sum / valid.length / 5) * 10 : 0;
// //   }, [editedData.section4]);

// //   const computedSupervisorCumulative = useMemo(() => {
// //     return section2SupervisorTotal + section3SupervisorTotal + section4SupervisorTotal;
// //   }, [section2SupervisorTotal, section3SupervisorTotal, section4SupervisorTotal]);

// //   useEffect(() => {
// //     setEditedData((prev) => ({
// //       ...prev,
// //       summary: {
// //         ...prev.summary,
// //         supervisorCumulative: Number(computedSupervisorCumulative.toFixed(2)),
// //         supervisorGrade: gradeFromScore(computedSupervisorCumulative),
// //       },
// //     }));
// //   }, [computedSupervisorCumulative]);

// //   /* ================= HANDLERS ================= */
// //   const handleSection2Change = (monthIndex, goalType, goalIndex, field, value) => {
// //     setEditedData((prev) => {
// //       const next = [...prev.section2];
// //       const month = { ...next[monthIndex] };
// //       const goalsList = [...(month[goalType] || [])];
// //       goalsList[goalIndex] = { ...goalsList[goalIndex], [field]: value };
// //       month[goalType] = goalsList;
// //       next[monthIndex] = month;
// //       return { ...prev, section2: next };
// //     });
// //   };

// //   const handleSectionChange = (section, index, field, value) => {
// //     setEditedData((prev) => {
// //       const next = [...(prev[section] || [])];
// //       next[index] = { ...next[index], [field]: value };
// //       return { ...prev, [section]: next };
// //     });
// //   };

// //   const handleSummaryChange = (field, value) => {
// //     setEditedData((prev) => ({
// //       ...prev,
// //       summary: { ...prev.summary, [field]: value },
// //     }));
// //   };

// //   const handleOverallCommentsChange = (value) => {
// //     setEditedData((prev) => ({
// //       ...prev,
// //       staffFeedback: { ...prev.staffFeedback, supervisorAttention: value },
// //     }));
// //   };

// //   const handleSave = async () => {
// //     try {
// //       setSaving(true);
// //       setError(null);
// //       setSuccess("");

// //       await api.put(`/appraisal/supervisor-score/${appraisalId}`, {
// //         section2: editedData.section2,
// //         section3: editedData.section3,
// //         section4: editedData.section4,
// //         summary: {
// //           supervisorCumulative: editedData.summary.supervisorCumulative,
// //           supervisorGrade: editedData.summary.supervisorGrade,
// //           supervisorOverallComments: editedData.summary.supervisorOverallComments || "",
// //         },
// //         staffFeedback: editedData.staffFeedback,
// //       });

// //       setSuccess("Appraisal updated successfully!");
// //       setTimeout(() => navigate("/supervisor/dashboard"), 1500);
// //     } catch (err) {
// //       console.error(err);
// //       setError(err.response?.data?.message || "Failed to save changes");
// //     } finally {
// //       setSaving(false);
// //     }
// //   };

// //   // Note the use of $collapsed to satisfy styled-components
// //   if (loading) return <Container $collapsed={collapsed}><NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} /><Main><InfoMessage>Loading appraisal...</InfoMessage></Main><Footer /></Container>;
// //   if (error) return <Container $collapsed={collapsed}><NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} /><Main><InfoMessage style={{ color: "red" }}>Error: {error}</InfoMessage></Main><Footer /></Container>;
// //   if (!appraisal) return <Container $collapsed={collapsed}><NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} /><Main><InfoMessage>Appraisal not found</InfoMessage></Main><Footer /></Container>;

// //   return (
// //     <Container $collapsed={collapsed}>
// //       <NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} />

// //       <Main>
// //         <PageHeader>
// //           <div>
// //             <Title>Supervisor's Assessment</Title>
// //             <Subtitle>
// //               Review full appraisal for {appraisal.userDetails?.username || "Staff"} — only supervisor fields are editable
// //             </Subtitle>
// //           </div>
// //         </PageHeader>

// //         <DocumentCard>
// //           <DocumentTop>
// //             <DocTitle>{appraisal.userDetails?.username || "Staff"}</DocTitle>
// //             <PeriodRow>
// //               <Pill>{appraisal.appraisalPeriod}</Pill>
// //             </PeriodRow>
// //           </DocumentTop>

// //           {/* =======================================================
// //               SECTION 2: PERFORMANCE ON GOALS
// //               ======================================================= */}
// //           <SectionBlock>
// //             <SectionHeading>
// //               <SectionTitle>PERFORMANCE ON GOALS</SectionTitle>
// //               {/* <SectionSub>Major Goals + Weekly Goals + Other Goals</SectionSub> */}
// //             </SectionHeading>

// //             {/* <NoticeBox>
// //               Staff achievements, weekly goals, and comments are fetched live from <strong>/goals/current-month</strong>.
// //               Only supervisor scores and comments are editable.
// //             </NoticeBox> */}

// //             {monthData.map((monthEntry, mIndex) => (
// //               <div key={mIndex} style={{ marginBottom: "48px" }}>
// //                 <SectionTitle style={{ marginBottom: 16, fontSize: "21px", color: "#1e40af" }}>
// //                   Performance for {formatValue(monthEntry.month)}
// //                 </SectionTitle>

// //                 {/* --- MAJOR GOALS TABLE --- */}
// //                 <SectionHeader>
// //                   <SecTitle>Major Goals</SecTitle>
// //                 </SectionHeader>

// //                 <TableWrapper>
// //                   <Table>
// //                     <thead>
// //                       <tr>
// //                         <Th style={{ width: "20%" }}>Goals</Th>
// //                         <Th style={{ width: "22%" }}>Achievements</Th>
// //                         <Th style={{ width: "7%" }}>Staff Action</Th>
// //                         <Th style={{ width: "7%" }}>Staff Quality</Th>
// //                         <Th style={{ width: "8%" }}>Sup. Action</Th>
// //                         <Th style={{ width: "8%" }}>Sup. Quality</Th>
// //                         <Th style={{ width: "28%" }}>Comments</Th>
// //                       </tr>
// //                     </thead>
// //                     <tbody>
// //                       {(monthEntry.majorGoals || []).map((goal, gIndex) => {
// //                         const weeks = goal.weekly || [];
// //                         const rowSpanCount = weeks.length > 0 ? weeks.length + 1 : 1;

// //                         return (
// //                           <React.Fragment key={goal.goalId || `major-${gIndex}`}>
// //                             <tr>
// //                               <Td style={rowSpanCount > 1 ? { borderBottom: "none", paddingBottom: "6px" } : {}}>
// //                                 <MonthlyHeader>
// //                                   <ExpandableText text={goal.goal} limit={85} />
// //                                   {goal.unit && <UnitBadge style={{ marginTop: "6px" }}>{goal.unit}</UnitBadge>}
// //                                   <GoalDate>
// //                                     {formatNiceDate(goal.startDate)} - {formatNiceDate(goal.deliveryDate)}
// //                                   </GoalDate>
// //                                 </MonthlyHeader>
// //                               </Td>

// //                               <Td style={rowSpanCount > 1 ? { borderBottom: "none", paddingBottom: "6px" } : {}}>
// //                                 <DisabledInput style={{ minHeight: "90px", background: "#fff" }}>
// //                                   <strong>Monthly Achievement:</strong><br />
// //                                   <ExpandableText text={goal.achievement || "No monthly achievement submitted."} limit={120} />
// //                                 </DisabledInput>
// //                               </Td>

// //                               <Td rowSpan={rowSpanCount}><SmallScore>{scoreValue(goal.staffActionScore)}</SmallScore></Td>
// //                               <Td rowSpan={rowSpanCount}><SmallScore>{scoreValue(goal.staffQualityScore)}</SmallScore></Td>

// //                               <Td rowSpan={rowSpanCount}>
// //                                 <EditableScore
// //                                   type="number" min="0" max="5" step="0.1"
// //                                   value={goal.supervisorActionScore ?? ""}
// //                                   onChange={(e) => handleSection2Change(mIndex, "majorGoals", gIndex, "supervisorActionScore", e.target.value)}
// //                                 />
// //                               </Td>
// //                               <Td rowSpan={rowSpanCount}>
// //                                 <EditableScore
// //                                   type="number" min="0" max="5" step="0.1"
// //                                   value={goal.supervisorQualityScore ?? ""}
// //                                   onChange={(e) => handleSection2Change(mIndex, "majorGoals", gIndex, "supervisorQualityScore", e.target.value)}
// //                                 />
// //                               </Td>

// //                               <Td rowSpan={rowSpanCount}>
// //                                 <CommentLabel $color="#ef4444">Staff Comment</CommentLabel>
// //                                 <DisabledInput style={{ background: "white", padding: "8px", minHeight: "40px" }}>
// //                                   {goal.staffComment || "No staff comment"}
// //                                 </DisabledInput>

// //                                 <CommentLabel $color="#0f172a" $marginTop="12px">Supervisor's Comment</CommentLabel>
// //                                 <EditableText
// //                                   value={goal.supervisorComments || ""}
// //                                   onChange={(e) => handleSection2Change(mIndex, "majorGoals", gIndex, "supervisorComments", e.target.value)}
// //                                   placeholder="Enter supervisor comment..."
// //                                 />
// //                               </Td>
// //                             </tr>

// //                             {/* WEEKLY ROWS */}
// //                             {weeks.map((week, index) => {
// //                               const isLast = index === weeks.length - 1;
// //                               const cellStyle = {
// //                                 borderBottom: isLast ? undefined : "none",
// //                                 borderRight: "1px solid #e2e8f0", 
// //                                 paddingTop: "6px", paddingBottom: isLast ? undefined : "6px"
// //                               };
// //                               const wWeek = week.week || `Week ${index + 1}`;
                              
// //                               return (
// //                                 <tr key={`week-${index}`}>
// //                                   <Td style={cellStyle}>
// //                                     <WeekGoalBox>
// //                                       <strong>{wWeek} Goal</strong>
// //                                       <div style={{ marginTop: "6px" }}>
// //                                         <ExpandableText text={week.weeklyGoal || week.goal} limit={70} isWeekly={true} />
// //                                       </div>
// //                                     </WeekGoalBox>
// //                                   </Td>
// //                                   <Td style={cellStyle}>
// //                                     <WeekAchBox>
// //                                       <strong>{wWeek} Achievement</strong>
// //                                       <div style={{ marginTop: "6px" }}>
// //                                         {(week.weeklyAchievement || week.achievements)?.trim() 
// //                                           ? (week.weeklyAchievement || week.achievements) 
// //                                           : "No achievement submitted."}
// //                                       </div>
// //                                       {/* {week.weeklyComment && (
// //                                         <>
// //                                           <div style={{ marginTop: "8px", fontSize: "11px", color: "#64748b", fontWeight: "700" }}>Staff Comment:</div>
// //                                           <div style={{ fontSize: "12px", color: "#334155", marginTop: "2px" }}>{week.weeklyComment}</div>
// //                                         </>
// //                                       )} */}
// //                                       {/* Unit */}
// //                                     </WeekAchBox>
// //                                   </Td>
// //                                 </tr>
// //                               );
// //                             })}
// //                           </React.Fragment>
// //                         );
// //                       })}
// //                     </tbody>
// //                   </Table>
// //                 </TableWrapper>

// //                 {/* --- OTHER GOALS TABLE --- */}
// //                 <SectionHeader>
// //                   <SecTitle>Other Goals</SecTitle>
// //                 </SectionHeader>

// //                 <TableWrapper>
// //                   <Table>
// //                     <thead>
// //                       <tr>
// //                         <Th style={{ width: "20%" }}>Goals</Th>
// //                         <Th style={{ width: "22%" }}>Achievements</Th>
// //                         <Th style={{ width: "7%" }}>Staff Action</Th>
// //                         <Th style={{ width: "7%" }}>Staff Quality</Th>
// //                         <Th style={{ width: "8%" }}>Sup. Action</Th>
// //                         <Th style={{ width: "8%" }}>Sup. Quality</Th>
// //                         <Th style={{ width: "28%" }}>Comments</Th>
// //                       </tr>
// //                     </thead>
// //                     <tbody>
// //                       {(monthEntry.otherGoals || []).map((goal, gIndex) => (
// //                         <tr key={goal.goalId || `other-${gIndex}`}>
// //                           <Td>
// //                             <RoutineHeader>
// //                               <ExpandableText text={goal.goal} limit={85} />
// //                               {goal.unit && <UnitBadge>{goal.unit}</UnitBadge>}
// //                               <GoalDate>Due {formatNiceDate(goal.deliveryDate)}</GoalDate>
// //                             </RoutineHeader>
// //                           </Td>
// //                           <Td>
// //                             <DisabledInput style={{ background: "#fff" }}>
// //                                <ExpandableText text={goal.achievement || "No achievement submitted."} limit={120} />
// //                             </DisabledInput>
// //                           </Td>
// //                           <Td><SmallScore>{scoreValue(goal.staffActionScore)}</SmallScore></Td>
// //                           <Td><SmallScore>{scoreValue(goal.staffQualityScore)}</SmallScore></Td>
// //                           <Td>
// //                             <EditableScore
// //                               type="number" min="0" max="5" step="0.1"
// //                               value={goal.supervisorActionScore ?? ""}
// //                               onChange={(e) => handleSection2Change(mIndex, "otherGoals", gIndex, "supervisorActionScore", e.target.value)}
// //                             />
// //                           </Td>
// //                           <Td>
// //                             <EditableScore
// //                               type="number" min="0" max="5" step="0.1"
// //                               value={goal.supervisorQualityScore ?? ""}
// //                               onChange={(e) => handleSection2Change(mIndex, "otherGoals", gIndex, "supervisorQualityScore", e.target.value)}
// //                             />
// //                           </Td>
// //                           <Td>
// //                             <CommentLabel $color="#ef4444">Staff Comment</CommentLabel>
// //                             <DisabledInput style={{ background: "white", padding: "8px", minHeight: "40px" }}>
// //                               {goal.staffComment || "No staff comment"}
// //                             </DisabledInput>

// //                             <CommentLabel $color="#0f172a" $marginTop="12px">Supervisor's Comment</CommentLabel>
// //                             <EditableText
// //                               value={goal.supervisorComments || ""}
// //                               onChange={(e) => handleSection2Change(mIndex, "otherGoals", gIndex, "supervisorComments", e.target.value)}
// //                               placeholder="Enter supervisor comment..."
// //                             />
// //                           </Td>
// //                         </tr>
// //                       ))}
// //                     </tbody>
// //                   </Table>
// //                 </TableWrapper>

// //                 {/* --- MOBILE VIEW --- */}
// //                 <MobileGrid>
// //                    {(monthEntry.majorGoals || []).map((goal, gIndex) => {
// //                      const weeks = goal.weekly || [];
// //                      return (
// //                        <MobileCard key={goal.goalId || `mob-major-${gIndex}`} $isRoutine={false}>
// //                           <MobileTop>
// //                             <MobilePill $isRoutine={false}>Major Goal</MobilePill>
// //                           </MobileTop>
// //                           <MobileTitle>
// //                             <ExpandableText text={goal.goal} limit={90} />
// //                           </MobileTitle>
// //                           <MobileDate>{formatNiceDate(goal.startDate)} - {formatNiceDate(goal.deliveryDate)}</MobileDate>

// //                           <MobileLabel>Monthly Achievement</MobileLabel>
// //                           <DisabledInput style={{ background: "#fff", marginBottom: "12px" }}>
// //                             {goal.achievement || "No monthly achievement submitted."}
// //                           </DisabledInput>

// //                           {/* Mobile Weekly Goals */}
// //                           {weeks.length > 0 && (
// //                             <div style={{ marginTop: "12px", display: "flex", flexDirection: "column", gap: "10px", marginBottom: "16px" }}>
// //                               {weeks.map((w, wIdx) => {
// //                                 const wWeek = w.week || `Week ${wIdx + 1}`;
// //                                 return (
// //                                   <div key={wIdx} style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px", border: "1px solid #e2e8f0" }}>
// //                                     <div style={{ color: "#ef4444", fontWeight: "700", fontSize: "12px" }}>{wWeek} Goal</div>
// //                                     <div style={{ fontSize: "13px", marginTop: "4px" }}>{w.weeklyGoal || w.goal}</div>
// //                                     <div style={{ color: "#16a34a", fontWeight: "700", fontSize: "12px", marginTop: "10px" }}>{wWeek} Achievement</div>
// //                                     <div style={{ fontSize: "13px", marginTop: "4px" }}>{(w.weeklyAchievement || w.achievements) || "None"}</div>
// //                                     {w.weeklyComment && (
// //                                       <>
// //                                         <div style={{ color: "#64748b", fontWeight: "700", fontSize: "12px", marginTop: "10px" }}>Staff Comment</div>
// //                                         <div style={{ fontSize: "13px", marginTop: "4px" }}>{w.weeklyComment}</div>
// //                                       </>
// //                                     )}
// //                                   </div>
// //                                 )
// //                               })}
// //                             </div>
// //                           )}

// //                           <MobileLabel>Staff Scores</MobileLabel>
// //                           <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
// //                             <SmallScore>A: {scoreValue(goal.staffActionScore)}</SmallScore>
// //                             <SmallScore>Q: {scoreValue(goal.staffQualityScore)}</SmallScore>
// //                           </div>

// //                           <MobileLabel>Staff Comment</MobileLabel>
// //                           <DisabledInput style={{ marginBottom: "10px", background: "white" }}>
// //                             {goal.staffComment || "No comment."}
// //                           </DisabledInput>

// //                           <MobileLabel>Supervisor Action Score</MobileLabel>
// //                           <EditableScore type="number" min="0" max="5" step="0.1" value={goal.supervisorActionScore ?? ""} onChange={(e) => handleSection2Change(mIndex, "majorGoals", gIndex, "supervisorActionScore", e.target.value)} />
                          
// //                           <MobileLabel>Supervisor Quality Score</MobileLabel>
// //                           <EditableScore type="number" min="0" max="5" step="0.1" value={goal.supervisorQualityScore ?? ""} onChange={(e) => handleSection2Change(mIndex, "majorGoals", gIndex, "supervisorQualityScore", e.target.value)} />
                          
// //                           <MobileLabel>Supervisor Comment</MobileLabel>
// //                           <EditableText value={goal.supervisorComments || ""} onChange={(e) => handleSection2Change(mIndex, "majorGoals", gIndex, "supervisorComments", e.target.value)} />
// //                        </MobileCard>
// //                      )
// //                    })}

// //                    {(monthEntry.otherGoals || []).map((goal, gIndex) => (
// //                      <MobileCard key={goal.goalId || `mob-other-${gIndex}`} $isRoutine={true}>
// //                           <MobileTop>
// //                             <MobilePill $isRoutine={true}>Other Goal</MobilePill>
// //                           </MobileTop>
// //                           <MobileTitle>
// //                             <ExpandableText text={goal.goal} limit={90} />
// //                           </MobileTitle>
// //                           <MobileDate>Due {formatNiceDate(goal.deliveryDate)}</MobileDate>

// //                           <MobileLabel>Achievement</MobileLabel>
// //                           <DisabledInput style={{ background: "#fff", marginBottom: "12px" }}>
// //                             {goal.achievement || "No achievement submitted."}
// //                           </DisabledInput>

// //                           <MobileLabel>Staff Scores</MobileLabel>
// //                           <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
// //                             <SmallScore>A: {scoreValue(goal.staffActionScore)}</SmallScore>
// //                             <SmallScore>Q: {scoreValue(goal.staffQualityScore)}</SmallScore>
// //                           </div>

// //                           <MobileLabel>Staff Comment</MobileLabel>
// //                           <DisabledInput style={{ marginBottom: "10px", background: "white" }}>
// //                             {goal.staffComment || "No comment."}
// //                           </DisabledInput>

// //                           <MobileLabel>Supervisor Action Score</MobileLabel>
// //                           <EditableScore type="number" min="0" max="5" step="0.1" value={goal.supervisorActionScore ?? ""} onChange={(e) => handleSection2Change(mIndex, "otherGoals", gIndex, "supervisorActionScore", e.target.value)} />
                          
// //                           <MobileLabel>Supervisor Quality Score</MobileLabel>
// //                           <EditableScore type="number" min="0" max="5" step="0.1" value={goal.supervisorQualityScore ?? ""} onChange={(e) => handleSection2Change(mIndex, "otherGoals", gIndex, "supervisorQualityScore", e.target.value)} />
                          
// //                           <MobileLabel>Supervisor Comment</MobileLabel>
// //                           <EditableText value={goal.supervisorComments || ""} onChange={(e) => handleSection2Change(mIndex, "otherGoals", gIndex, "supervisorComments", e.target.value)} />
// //                        </MobileCard>
// //                    ))}
// //                 </MobileGrid>
// //               </div>
// //             ))}
// //           </SectionBlock>

// //           <SectionBlock>
// //             <SectionHeading>
// //               <SectionTitle>WORK ETHIC & LEADERSHIP</SectionTitle>
// //               <SectionSub>Staff scores remain visible, supervisor scores editable</SectionSub>
// //             </SectionHeading>
// //             <TableWrap>
// //               <LegacyTable>
// //                 <thead>
// //                   <tr>
// //                     <th>S/N</th>
// //                     <th>ATTRIBUTE</th>
// //                     <th>DESCRIPTION</th>
// //                     <th>STAFF SCORE</th>
// //                     <th>STAFF COMMENTS</th>
// //                     <th>SUPERVISOR SCORE</th>
// //                     <th>SUPERVISOR COMMENTS</th>
// //                   </tr>
// //                 </thead>
// //                 <tbody>
// //                   {(editedData.section3 || []).map((item, index) => (
// //                     <tr key={index}>
// //                       <td>{index + 1}</td>
// //                       <td><DisabledInput>{formatValue(item.attribute)}</DisabledInput></td>
// //                       <td><DisabledInput>{formatValue(item.description)}</DisabledInput></td>
// //                       <td><SmallScore>{scoreValue(item.staffScore)}</SmallScore></td>
// //                       <td><DisabledInput>{formatValue(item.staffComments)}</DisabledInput></td>
// //                       <td>
// //                         <EditableScore
// //                           type="number" min="0" max="5" step="0.1"
// //                           value={item.supervisorScore ?? ""}
// //                           onChange={(e) => handleSectionChange("section3", index, "supervisorScore", e.target.value)}
// //                         />
// //                       </td>
// //                       <td>
// //                         <EditableText
// //                           value={item.supervisorComments || ""}
// //                           onChange={(e) => handleSectionChange("section3", index, "supervisorComments", e.target.value)}
// //                         />
// //                       </td>
// //                     </tr>
// //                   ))}
// //                 </tbody>
// //               </LegacyTable>
// //             </TableWrap>
// //           </SectionBlock>

// //           <SectionBlock>
// //             <SectionHeading>
// //               <SectionTitle>COMPLIANCE</SectionTitle>
// //               <SectionSub>Staff scores remain visible, supervisor scores editable</SectionSub>
// //             </SectionHeading>
// //             <TableWrap>
// //               <LegacyTable>
// //                 <thead>
// //                   <tr>
// //                     <th>S/N</th>
// //                     <th>PROTOCOL</th>
// //                     <th>DESCRIPTION</th>
// //                     <th>STAFF SCORE</th>
// //                     <th>STAFF COMMENTS</th>
// //                     <th>SUPERVISOR SCORE</th>
// //                     <th>SUPERVISOR COMMENTS</th>
// //                   </tr>
// //                 </thead>
// //                 <tbody>
// //                   {(editedData.section4 || []).map((item, index) => (
// //                     <tr key={index}>
// //                       <td>{index + 1}</td>
// //                       <td><DisabledInput>{formatValue(item.attribute)}</DisabledInput></td>
// //                       <td><DisabledInput>{formatValue(item.description)}</DisabledInput></td>
// //                       <td><SmallScore>{scoreValue(item.staffScore)}</SmallScore></td>
// //                       <td><DisabledInput>{formatValue(item.staffComments)}</DisabledInput></td>
// //                       <td>
// //                         <EditableScore
// //                           type="number" min="0" max="5" step="0.1"
// //                           value={item.supervisorScore ?? ""}
// //                           onChange={(e) => handleSectionChange("section4", index, "supervisorScore", e.target.value)}
// //                         />
// //                       </td>
// //                       <td>
// //                         <EditableText
// //                           value={item.supervisorComments || ""}
// //                           onChange={(e) => handleSectionChange("section4", index, "supervisorComments", e.target.value)}
// //                         />
// //                       </td>
// //                     </tr>
// //                   ))}
// //                 </tbody>
// //               </LegacyTable>
// //             </TableWrap>
// //           </SectionBlock>

// //           <SectionBlock>
// //             <SectionHeading>
// //               <SectionTitle>SUMMARY OF PERFORMANCE</SectionTitle>
// //               <SectionSub>Staff summary remains visible, supervisor summary editable</SectionSub>
// //             </SectionHeading>

// //             <SummaryGrid>
// //               <SummaryCard>
// //                 <CardTitle>500 Character Citation</CardTitle>
// //                 <TextBlock>{formatValue(editedData.summary?.citation)}</TextBlock>
// //               </SummaryCard>

// //               <SummaryCard>
// //                 <CardTitle>Total Scores</CardTitle>
// //                 <ScoreList>
// //                   <ScoreRow><span>Staff Section 2</span><strong>{formatValue(editedData.summary?.section2, 0)}</strong></ScoreRow>
// //                   <ScoreRow><span>Staff Section 3</span><strong>{formatValue(editedData.summary?.section3, 0)}</strong></ScoreRow>
// //                   <ScoreRow><span>Staff Section 4</span><strong>{formatValue(editedData.summary?.section4, 0)}</strong></ScoreRow>
// //                   <ScoreRow><span>Staff Cumulative</span><strong>{formatValue(editedData.summary?.cumulative, 0)}</strong></ScoreRow>
// //                   <ScoreRow><span>Supervisor Cumulative</span><strong>{formatValue(editedData.summary?.supervisorCumulative, 0)}</strong></ScoreRow>
// //                 </ScoreList>

// //                 <div style={{ marginTop: 18, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 18, flexWrap: "wrap" }}>
// //                   <div>
// //                     <div style={{ fontSize: 13, color: "#64748b", marginBottom: 4 }}>Staff Grade</div>
// //                     <BigGrade>{formatValue(editedData.summary?.grade, "—")}</BigGrade>
// //                   </div>
// //                   <div>
// //                     <div style={{ fontSize: 13, color: "#64748b", marginBottom: 4 }}>Supervisor Grade</div>
// //                     <BigGrade style={{ color: "#0f766e" }}>{formatValue(editedData.summary?.supervisorGrade, "—")}</BigGrade>
// //                   </div>
// //                 </div>
// //               </SummaryCard>
// //             </SummaryGrid>

// //             <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginTop: 18 }}>
// //               <div>
// //                 <CardTitle style={{fontSize: 14, color: "#64748b"}}>Supervisor Cumulative</CardTitle>
// //                 <EditableScore
// //                   type="number"
// //                   value={editedData.summary?.supervisorCumulative ?? ""}
// //                   onChange={(e) => handleSummaryChange("supervisorCumulative", e.target.value)}
// //                   style={{ width: "100%", maxWidth: "100%" }}
// //                 />
// //               </div>
// //               <div>
// //                 <CardTitle style={{fontSize: 14, color: "#64748b"}}>Supervisor Grade</CardTitle>
// //                 <EditableText
// //                   value={editedData.summary?.supervisorGrade || ""}
// //                   onChange={(e) => handleSummaryChange("supervisorGrade", e.target.value)}
// //                   style={{ minHeight: 42 }}
// //                 />
// //               </div>
// //             </div>
// //           </SectionBlock>

// //           <SectionBlock>
// //             <SectionHeading>
// //               <SectionTitle>SUPERVISOR’S OVERALL COMMENTS</SectionTitle>
// //               <SectionSub>Editable by supervisor</SectionSub>
// //             </SectionHeading>
// //             <EditableText
// //               value={editedData.staffFeedback?.supervisorAttention || ""}
// //               onChange={(e) => handleOverallCommentsChange(e.target.value)}
// //               placeholder="Enter supervisor overall comments..."
// //             />
// //           </SectionBlock>

// //           <SectionBlock>
// //             <SectionHeading>
// //               <SectionTitle>HEAD OF DEPARTMENT’S OVERALL COMMENTS</SectionTitle>
// //               <SectionSub>Read only for now</SectionSub>
// //             </SectionHeading>
// //             <TextBlock>{formatValue(editedData.summary?.hodOverallComments)}</TextBlock>
// //           </SectionBlock>

// //           <SaveButton onClick={handleSave} disabled={saving}>
// //             {saving ? "Saving Changes..." : "Save Supervisor Assessment"}
// //           </SaveButton>

// //           {success && <p style={{ color: "green", fontWeight: 600 }}>{success}</p>}
// //           {error && <p style={{ color: "red", fontWeight: 600 }}>{error}</p>}
// //         </DocumentCard>
// //       </Main>
// //       <Footer />
// //     </Container>
// //   );
// // };

// // export default SupervisorAppraisalForm;













// // // // 1. Calculate how many weeks (Mondays) are in the appraisal period
// // //   const getWeeksInMonth = (appraisalPeriod) => {
// // //     if (!appraisalPeriod) return 4;
// // //     const periodDate = new Date(`${appraisalPeriod} 1`);
// // //     if (isNaN(periodDate)) return 4;
    
// // //     const year = periodDate.getFullYear();
// // //     const monthIndex = periodDate.getMonth();
// // //     let date = new Date(year, monthIndex, 1);
// // //     let mondays = 0;
    
// // //     while (date.getMonth() === monthIndex) {
// // //       if (date.getDay() === 1) mondays++;
// // //       date.setDate(date.getDate() + 1);
// // //     }
// // //     return mondays > 0 ? mondays : 4; // Fallback to 4 if something goes wrong
// // //   };

// // //   const numberOfWeeks = getWeeksInMonth(appraisal?.appraisalPeriod);

// // //   // 2. Temporary state to hold the Admin's weekly inputs for Items 12-15
// // //   // Structure: { rowIndex: [week1Score, week2Score, week3Score, ...] }
// // //   const [weeklyAdminScores, setWeeklyAdminScores] = useState({});

// // //   // 3. The Auto-Calculator Function
// // //   const handleWeeklyScoreChange = (itemIndex, weekIndex, value) => {
// // //     // Ensure value doesn't exceed 5
// // //     let numValue = Number(value);
// // //     if (numValue > 5) numValue = 5;
// // //     if (numValue < 0) numValue = 0;

// // //     // Update the temporary weekly array
// // //     const currentWeeks = weeklyAdminScores[itemIndex] || Array(numberOfWeeks).fill(0);
// // //     const newWeeks = [...currentWeeks];
// // //     newWeeks[weekIndex] = numValue;
    
// // //     setWeeklyAdminScores(prev => ({ ...prev, [itemIndex]: newWeeks }));

// // //     // Auto-calculate the average
// // //     const totalPoints = newWeeks.reduce((a, b) => a + b, 0);
// // //     const average = totalPoints / numberOfWeeks;
    
// // //     // Generate the math breakdown string for transparency
// // //     const formulaString = `Weekly Points-${newWeeks.join('+')}=${totalPoints}. Monthly Score-${totalPoints}/${numberOfWeeks}=${average.toFixed(2)}`;

// // //     // Instantly update the main section 4 state with the new average AND the breakdown comment
// // //     setEditedData(prev => {
// // //       const nextSec4 = [...prev.section4];
// // //       nextSec4[itemIndex] = { 
// // //         ...nextSec4[itemIndex], 
// // //         supervisorScore: String(average.toFixed(2)),
// // //         supervisorComments: formulaString // Saves the mathematical proof directly into the comment!
// // //       };
// // //       return { ...prev, section4: nextSec4 };
// // //     });
// // //   };


// // // <tbody>
// // //   {(editedData.section4 || []).map((item, index) => {
// // //     // Identify the specific sections
// // //     const isFreeTypeAdmin = index === 9 || index === 10; // Items 10 & 11
// // //     const isWeeklyAdmin = index >= 11 && index <= 14;    // Items 12 to 15
// // //     const isAdminEditable = isFreeTypeAdmin || isWeeklyAdmin;

// // //     return (
// // //       <tr key={index}>
// // //         <td>{index + 1}</td>
// // //         <td><DisabledInput>{formatValue(item.attribute)}</DisabledInput></td>
// // //         <td><DisabledInput>{formatValue(item.description)}</DisabledInput></td>
        
// // //         {/* Staff Score & Comments (Read Only) */}
// // //         <td><SmallScore muted>{scoreValue(item.staffScore)}</SmallScore></td>
// // //         <td><DisabledInput>{formatValue(item.staffComments)}</DisabledInput></td>
        
// // //         {/* ADMIN SCORING COLUMN */}
// // //         <td>
// // //           {isFreeTypeAdmin && (
// // //             // ITEMS 10 & 11: Free Type 0-5
// // //             <div>
// // //               <div style={{ fontSize: '11px', color: '#1d4ed8', fontWeight: 'bold', marginBottom: '4px' }}>
// // //                 Admin Free Type:
// // //               </div>
// // //               <EditableScore
// // //                 type="number" min="0" max="5" step="0.1"
// // //                 value={item.supervisorScore ?? ""}
// // //                 onChange={(e) => handleSectionChange("section4", index, "supervisorScore", e.target.value)}
// // //               />
// // //             </div>
// // //           )}

// // //           {isWeeklyAdmin && (
// // //             // ITEMS 12 to 15: Weekly Auto-Calculator Grid
// // //             <div style={{ background: "#f8fafc", padding: "10px", borderRadius: "10px", border: "1px solid #e2e8f0" }}>
// // //               <div style={{ fontSize: '11px', color: '#ea580c', fontWeight: 'bold', marginBottom: '8px' }}>
// // //                 Enter Weekly Scores (Max 5/wk):
// // //               </div>
// // //               <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginBottom: "10px" }}>
// // //                 {Array.from({ length: numberOfWeeks }).map((_, weekIndex) => (
// // //                   <div key={weekIndex} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
// // //                     <span style={{ fontSize: "10px", color: "#64748b" }}>Wk {weekIndex + 1}</span>
// // //                     <input
// // //                       type="number"
// // //                       min="0" max="5"
// // //                       style={{ width: "40px", padding: "4px", textAlign: "center", border: "1px solid #cbd5e1", borderRadius: "6px" }}
// // //                       value={weeklyAdminScores[index]?.[weekIndex] ?? ""}
// // //                       onChange={(e) => handleWeeklyScoreChange(index, weekIndex, e.target.value)}
// // //                     />
// // //                   </div>
// // //                 ))}
// // //               </div>
// // //               <div style={{ display: "flex", alignItems: "center", gap: "8px", borderTop: "1px solid #e2e8f0", paddingTop: "8px" }}>
// // //                 <span style={{ fontSize: "12px", fontWeight: "bold" }}>Monthly Avg:</span>
// // //                 <SmallScore>{scoreValue(item.supervisorScore)}</SmallScore>
// // //               </div>
// // //             </div>
// // //           )}

// // //           {!isAdminEditable && (
// // //             // ITEMS 1 to 9: System/Supervisor Locked
// // //             <div>
// // //               <div style={{ fontSize: '10px', color: '#64748b', marginBottom: '4px' }}>System Locked</div>
// // //               <SmallScore muted>{scoreValue(item.supervisorScore)}</SmallScore>
// // //             </div>
// // //           )}
// // //         </td>

// // //         {/* ADMIN COMMENTS COLUMN */}
// // //         <td>
// // //           {isAdminEditable ? (
// // //             <EditableText
// // //               value={item.supervisorComments || ""}
// // //               onChange={(e) => handleSectionChange("section4", index, "supervisorComments", e.target.value)}
// // //               placeholder="Admin breakdown/comments..."
// // //             />
// // //           ) : (
// // //             <DisabledInput>{formatValue(item.supervisorComments)}</DisabledInput>
// // //           )}
// // //         </td>
// // //       </tr>
// // //     );
// // //   })}
// // // </tbody>




// import React, { useEffect, useMemo, useState } from "react";
// import styled from "styled-components";
// import NavBarSuper from "./NavBarSuper";
// import Footer from "./Footer";
// import api from "../api";
// import { useParams, useNavigate, useLocation } from "react-router-dom";

// /* ================= HELPERS ================= */
// const formatValue = (value, fallback = "—") => {
//   if (value === null || value === undefined || value === "") return fallback;
//   return value;
// };

// const scoreValue = (value) => {
//   if (value === null || value === undefined || value === "") return "—";
//   return value;
// };

// const gradeFromScore = (score) => {
//   const s = Number(score || 0);
//   if (s >= 90) return "A";
//   if (s >= 80) return "B";
//   if (s >= 70) return "C";
//   if (s >= 60) return "D";
//   return "E";
// };

// const getWeekOfMonth = (dateString) => {
//   if (!dateString) return "Week 1";
//   const d = new Date(dateString);
//   const firstDay = new Date(d.getFullYear(), d.getMonth(), 1).getDay();
//   return `Week ${Math.ceil((d.getDate() + firstDay) / 7)}`;
// };

// const formatNiceDate = (dateString) => {
//   if (!dateString) return "—";
//   return new Date(dateString).toDateString();
// };

// const getGoalUnit = (goal) => {
//   return goal.unit || goal.subDepartment || "General Unit";
// };

// /* ================= SHARED COMPONENTS ================= */
// const ExpandableText = ({ text, limit = 90, isWeekly = false }) => {
//   const [isExpanded, setIsExpanded] = useState(false);
//   if (!text) return null;

//   const textStyle = {
//     maxWidth: "350px",
//     wordWrap: "break-word",
//     marginTop: isWeekly ? "4px" : "10px",
//     fontWeight: isWeekly ? "600" : "700",
//     color: "#0f172a",
//     fontSize: isWeekly ? "13px" : "14px",
//     lineHeight: "1.5",
//   };

//   if (String(text).length <= limit) {
//     return <div style={textStyle}>{text}</div>;
//   }

//   return (
//     <div style={{ ...textStyle, display: "block" }}>
//       <span style={{ display: "inline" }}>
//         {isExpanded ? text : `${String(text).substring(0, limit)}...`}
//       </span>
//       <button
//         type="button"
//         onClick={(e) => {
//           e.preventDefault();
//           setIsExpanded(!isExpanded);
//         }}
//         style={{
//           background: "none", border: "none", color: "#2563eb",
//           cursor: "pointer", fontSize: "12px", fontWeight: "800",
//           padding: "0 0 0 6px", textDecoration: "underline",
//         }}
//       >
//         {isExpanded ? "Show less" : "Read more"}
//       </button>
//     </div>
//   );
// };

// /* ================= LAYOUT STYLES ================= */
// const Container = styled.div`
//   --page-bg: linear-gradient(180deg, #f8fafc 0%, #edf4ff 100%);
//   min-height: 100vh; background: var(--page-bg); margin-left: 0;
// `;

// const Main = styled.main`
//   width: min(1450px, calc(100% - 32px)); margin: 0 auto; padding: 90px 0 60px;
//   @media (max-width: 1024px) { width: min(100%, calc(100% - 24px)); padding: 84px 0 40px; }
//   @media (max-width: 576px) { width: min(100%, calc(100% - 16px)); padding: 80px 0 28px; }
// `;

// const TableWrap = styled.div`
//   overflow-x: auto;
//   border: 1px solid #e5e7eb;
//   border-radius: 16px;
//   margin-bottom: 18px;

//   @media (max-width: 900px) { display: none; }
// `;

// const PageHeader = styled.div`
//   display: flex; justify-content: space-between; align-items: flex-end;
//   gap: 16px; flex-wrap: wrap; margin-bottom: 24px;
// `;

// const Title = styled.h1`
//   font-size: clamp(1.6rem, 1.2rem + 1vw, 2.1rem); font-weight: 800; color: #0f172a; margin: 0 0 6px;
// `;

// const Subtitle = styled.p`
//   color: #64748b; font-size: 15px; margin: 0; line-height: 1.6;
// `;

// const DocumentCard = styled.div`
//   background: white; border-radius: 24px; padding: 24px;
//   box-shadow: 0 22px 55px rgba(15, 23, 42, 0.08); border: 1px solid #e8eef7;
//   @media (max-width: 576px) { padding: 16px; border-radius: 20px; }
// `;

// const DocumentTop = styled.div`
//   border-bottom: 2px solid #e2e8f0; padding-bottom: 18px; margin-bottom: 22px;
// `;

// const DocTitle = styled.h2`
//   font-size: clamp(1.3rem, 1.1rem + 0.6vw, 1.7rem); font-weight: 800; color: #0f172a; margin: 0 0 10px;
// `;

// const PeriodRow = styled.div`
//   display: flex; flex-wrap: wrap; gap: 12px;
// `;

// const Pill = styled.div`
//   display: inline-flex; align-items: center; padding: 8px 12px;
//   background: ${(props) => props.bg || "#eff6ff"};
//   color: ${(props) => props.color || "#1d4ed8"};
//   border-radius: 999px; font-size: 13px; font-weight: 700;
// `;

// const SectionBlock = styled.section`
//   margin-top: 28px;
// `;

// const SectionHeading = styled.div`
//   background: linear-gradient(135deg, #0f172a, #1d4ed8);
//   color: white; border-radius: 16px; padding: 14px 18px; margin-bottom: 16px;
// `;

// const SectionTitle = styled.h3`
//   font-size: 18px; font-weight: 800; margin: 0 0 4px;
// `;

// const SectionSub = styled.p`
//   font-size: 13px; margin: 0; opacity: 0.9;
// `;

// const SectionHeader = styled.div`
//   margin-bottom: 18px;
// `;

// const SecTitle = styled.h2`
//   margin: 0; font-size: clamp(1.2rem, 1rem + 0.7vw, 1.7rem); font-weight: 800;
// `;

// const TableWrapper = styled.div`
//   width: 100%; overflow-x: auto; border-radius: 12px;
//   border: 1px solid rgba(148, 163, 184, 0.14); margin-bottom: 24px;
//   @media (max-width: 1024px) { display: none; }
// `;

// const Table = styled.table`
//   width: 100%; border-collapse: collapse; background: white; table-layout: fixed;
// `;

// const Th = styled.th`
//   background: #fef2f2; padding: 12px 10px; text-align: left;
//   font-size: 12px; font-weight: 800; color: #7f1d1d;
//   border-bottom: 2px solid #e2e8f0; border-right: 1px solid #e2e8f0; border-left: 1px solid #e2e8f0;
//   vertical-align: middle; line-height: 1.3;
//   &:first-child { border-left: none; }
//   &:last-child { border-right: none; }
// `;

// const Td = styled.td`
//   padding: 10px 8px; border-bottom: 1px solid #e2e8f0; border-right: 1px solid #e2e8f0;
//   border-left: 1px solid #e2e8f0; vertical-align: top;
//   font-size: 13px; color: #1e293b; white-space: normal; word-break: break-word;
//   overflow-wrap: anywhere; line-height: 1.4;
//   &:first-child { border-left: none; }
//   &:last-child { border-right: none; }
// `;

// const MonthlyHeader = styled.div`
//   background: #fef2f2; padding: 12px 14px; border-left: 4px solid #ef4444; border-radius: 8px; height: 100%; box-sizing: border-box;
// `;

// const RoutineHeader = styled(MonthlyHeader)`
//   background: #fff7ed; border-left-color: #ea580c;
// `;

// const WeekGoalBox = styled.div`
//   padding: 12px; border-left: 3px solid #ef4444; background: #fdf2f2; border-radius: 6px; font-size: 12px; color: #334155; word-wrap: break-word; height: 100%; box-sizing: border-box;
// `;

// const WeekAchBox = styled.div`
//   padding: 12px; border-left: 3px solid #16a34a; background: #f0fdf4; border-radius: 6px; font-size: 12px; color: #334155; line-height: 1.5; word-break: break-word; height: 100%; box-sizing: border-box;
// `;

// const GoalDate = styled.div`
//   font-size: 11px; margin-top: 7px; color: #64748b;
// `;

// const UnitBadge = styled.span`
//   display: inline-block; margin-top: 6px; padding: 4px 10px; background: #e0f2fe; color: #0369a1; border: 1px solid #bae6fd; border-radius: 6px; font-size: 11px; font-weight: 800; letter-spacing: 0.05em; text-transform: uppercase;
// `;

// const CommentLabel = styled.div`
//   font-size: 10px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em;
//   color: ${({ $color }) => $color || "#64748b"}; margin-bottom: 4px; margin-top: ${({ $marginTop }) => $marginTop || "0"};
// `;
// const MobileDate = styled.div`
//   font-size: 12px;
//   color: #64748b;
// `;

// /* Mobile Styles */
// const MobileGrid = styled.div`
//   display: none;
//   @media (max-width: 1024px) { display: grid; gap: 16px; margin-bottom: 24px; }
// `;

// const MobileCard = styled.div`
//   background: white; border: 1px solid rgba(148, 163, 184, 0.14);
//   border-left: 5px solid ${({ $isRoutine }) => ($isRoutine ? "#ea580c" : "#ef4444")};
//   border-radius: 16px; padding: 16px; box-shadow: 0 4px 16px rgba(15, 23, 42, 0.05); display: flex; flex-direction: column; min-width: 0;
// `;

// const MobileTop = styled.div`
//   display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 8px;
// `;

// const MobilePill = styled.div`
//   display: inline-flex; align-items: center; padding: 4px 10px; border-radius: 999px; font-size: 11px; font-weight: 800; letter-spacing: 0.04em; text-transform: uppercase;
//   background: ${({ $isRoutine }) => $isRoutine ? "rgba(234,88,12,0.12)" : "rgba(220, 38, 38, 0.12)"};
//   color: ${({ $isRoutine }) => ($isRoutine ? "#c2410c" : "#b91c1c")};
// `;

// const MobileTitle = styled.div`
//   font-size: 14px; font-weight: 800; color: #0f172a; line-height: 1.4; margin-bottom: 4px; word-wrap: break-word; overflow-wrap: anywhere;
// `;

// const MobileLabel = styled.div`
//   font-size: 11px; font-weight: 800; margin-top: 16px; margin-bottom: 6px; color: #64748b; text-transform: uppercase; letter-spacing: 0.04em;
// `;

// const DisabledInput = styled.div`
//   min-height: 42px; border: 1px solid #e2e8f0; background: #f8fafc; color: #334155; border-radius: 10px; padding: 10px 12px; line-height: 1.5; white-space: pre-wrap;
// `;

// const SmallScore = styled.div`
//   width: 46px; min-height: 42px; display: inline-flex; align-items: center; justify-content: center; border-radius: 10px; border: 1px solid #dbe3ee; background: ${(props) => (props.muted ? "#f8fafc" : "#eef2ff")}; font-weight: 800; color: #0f172a;
// `;

// const ScoreList = styled.div`
//   display: grid; gap: 10px;
// `;

// const EditableScore = styled.input`
//   width: 100%; max-width: 60px; padding: 6px 4px; text-align: center; border: 1px solid #2563eb; border-radius: 8px; font-weight: 700; font-size: 14px; outline: none;
// `;

// const EditableText = styled.textarea`
//   width: 100%; min-height: 72px; border: 1px solid #2563eb; border-radius: 10px; padding: 10px 12px; font-size: 13px; resize: vertical; outline: none;
// `;

// const LegacyTable = styled.table`
//   width: 100%; min-width: 1200px; border-collapse: collapse;
//   th, td { border-bottom: 1px solid #e5e7eb; vertical-align: top; padding: 12px; text-align: left; font-size: 14px; }
//   thead th { background: #f8fafc; color: #0f172a; font-weight: 800; white-space: nowrap; }
// `;

// const SummaryGrid = styled.div`
//   display: grid; grid-template-columns: 1fr 1fr; gap: 18px;
//   @media (max-width: 980px) { grid-template-columns: 1fr; }
// `;

// const SummaryCard = styled.div`
//   border: 1px solid #e5e7eb; border-radius: 16px; padding: 24px; background: white;
//   display: flex; flex-direction: column; justify-content: center;
// `;

// const CardTitle = styled.h4`
//   margin: 0 0 16px; font-size: 1.1rem; font-weight: 800; color: #0f172a;
// `;

// const ScoreRow = styled.div`
//   display: flex; justify-content: space-between; align-items: center; gap: 12px; padding: 14px 18px;
//   border-radius: 12px; background: ${({ variant }) => variant === 'supervisor' ? '#f0fdf4' : '#eff6ff'};
//   border: 1px solid ${({ variant }) => variant === 'supervisor' ? '#bbf7d0' : '#bfdbfe'};
//   font-size: 14px; font-weight: 700; color: ${({ variant }) => variant === 'supervisor' ? '#166534' : '#1e40af'};
// `;

// const BigGrade = styled.div`
//   font-size: clamp(2.5rem, 2rem + 1vw, 3.5rem); font-weight: 900; color: #1d4ed8; margin-top: 10px;
// `;

// const TextBlock = styled.div`
//   min-height: 110px; border: 1px solid #e2e8f0; border-radius: 14px; background: #f8fafc; padding: 16px; white-space: pre-wrap; line-height: 1.7; color: #334155;
// `;

// const SaveButton = styled.button`
//   background: linear-gradient(135deg, #16a34a, #22c55e); color: white; border: none; padding: 16px 32px; border-radius: 16px; font-weight: 800; font-size: 1.1rem; cursor: pointer; margin: 30px 0 10px; transition: all 0.2s; width: 100%;
//   &:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 10px 20px rgba(22, 163, 74, 0.3); }
//   &:disabled { background: #94a3b8; cursor: not-allowed; }
// `;

// const InfoMessage = styled.div`
//   text-align: center; padding: 90px 20px; color: #64748b; background: white; border-radius: 20px; border: 1px dashed #cbd5e1;
// `;

// /* ================= MAIN COMPONENT ================= */
// const SupervisorAppraisalForm = ({ user }) => {
//   const [collapsed, setCollapsed] = useState(false);
//   const { appraisalId } = useParams();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [appraisal, setAppraisal] = useState(null);
//   const [goals, setGoals] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState(null);
//   const [success, setSuccess] = useState("");

//   const [editedData, setEditedData] = useState({
//     section2: [],
//     section3: [],
//     section4: [],
//     summary: {},
//     staffFeedback: {},
//   });

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         setError(null);

//         // 1. Fetch the appraisal
//         const appRes = await api.get(`/appraisal/${appraisalId}`);
//         const appraisalData = appRes.data?.appraisal || appRes.data?.data || appRes.data || {};
        
//         // 2. Identify the Staff ID
//         let staffId = location.state?.staffId;
//         if (!staffId) {
//             let rawStaffId = appraisalData.userId || appraisalData.userDetails || appraisalData.user || appraisalData.staffId;
//             if (rawStaffId) {
//                 if (typeof rawStaffId === "string") {
//                     staffId = rawStaffId;
//                 } else if (typeof rawStaffId === "object") {
//                     staffId = rawStaffId._id || rawStaffId.id || rawStaffId.$oid || "";
//                 }
//             }
//         }
//         staffId = String(staffId).trim();

//         if (!staffId || staffId === "[object Object]" || staffId === "undefined") {
//             console.error("CRITICAL ERROR: Could not find the Staff ID! Raw data:", appraisalData);
//             throw new Error("Cannot load goals: Staff ID is missing.");
//         }

//         // 3. Fetch goals
//         const goalsRes = await api.get(`/goals/staff-current-month/${staffId}`);
//         const currentGoals = goalsRes.data?.data || [];
//         const responseMonth = goalsRes.data?.month || "";

//         setAppraisal(appraisalData);
//         setGoals(currentGoals);

//         const mergedSection2 = buildMergedSection2(appraisalData, currentGoals, responseMonth);

//         setEditedData({
//           section2: mergedSection2,
//           section3: appraisalData.section3 || [],
//           section4: appraisalData.section4 || [],
//           summary: appraisalData.summary || {},
//           staffFeedback: appraisalData.staffFeedback || {},
//         });
//       } catch (err) {
//         console.error(err);
//         setError(err.response?.data?.message || err.message || "Failed to load data");
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (appraisalId) fetchData();
//   }, [appraisalId, location.state]);

//   const buildMergedSection2 = (appraisalData, currentGoals, responseMonth) => {
//     const existingSection2 = appraisalData.section2 || [];
//     const existingMonth = existingSection2[0] || {};

//     const monthlyGoals = currentGoals.filter(g => g.type === "monthly");
//     const routineGoals = currentGoals.filter(g => g.type === "routine");

//     const majorGoals = monthlyGoals.map((liveGoal) => {
//       const saved = existingSection2.flatMap(m => m.majorGoals || [])
//         .find(s => String(s.goal) === String(liveGoal.goal) || String(s.goalId) === String(liveGoal._id)) || {};

//       const liveWeeks = currentGoals
//         .filter(w => w.type === "weekly" && String(w.parentMonthlyGoal) === String(liveGoal._id))
//         .sort((a, b) => new Date(a.weeklyDeliveryDate || 0) - new Date(b.weeklyDeliveryDate || 0));
      
//       let weekly = [];
//       if (liveWeeks.length > 0) {
//           weekly = liveWeeks.map((w) => ({
//             week: getWeekOfMonth(w.weeklyDeliveryDate),
//             weeklyGoal: w.goal || "",
//             weeklyAchievement: w.achievements || "",
//             weeklyComment: w.comments || "",
//             weeklyDeliveryDate: w.weeklyDeliveryDate,
//           }));
//       } else if (saved.weekly && saved.weekly.length > 0) {
//           weekly = saved.weekly;
//       }

//       return {
//         goalId: liveGoal._id,
//         goal: liveGoal.goal || "",
//         unit: getGoalUnit(liveGoal),
//         startDate: liveGoal.startDate,
//         deliveryDate: liveGoal.deliveryDate,
//         achievement: saved.achievement || liveGoal.monthlyAchievements || liveGoal.achievements || "",
//         staffComment: saved.staffComment || liveGoal.monthlyComments || liveGoal.comments || saved.comments || "",
//         staffActionScore: saved.staffActionScore ?? "",
//         staffQualityScore: saved.staffQualityScore ?? "",
//         supervisorActionScore: saved.supervisorActionScore ?? "",
//         supervisorQualityScore: saved.supervisorQualityScore ?? "",
//         supervisorComments: saved.supervisorComments || "",
//         weekly,
//       };
//     });

//     const otherGoals = routineGoals.map((liveGoal) => {
//       const saved = existingSection2.flatMap(m => m.otherGoals || [])
//         .find(s => String(s.goal) === String(liveGoal.goal) || String(s.goalId) === String(liveGoal._id)) || {};

//       return {
//         goalId: liveGoal._id,
//         goal: liveGoal.goal || "",
//         unit: getGoalUnit(liveGoal),
//         deliveryDate: liveGoal.deliveryDate,
//         achievement: saved.achievement || liveGoal.achievements || "",
//         staffComment: saved.staffComment || liveGoal.comments || saved.comments || "",
//         staffActionScore: saved.staffActionScore ?? "",
//         staffQualityScore: saved.staffQualityScore ?? "",
//         supervisorActionScore: saved.supervisorActionScore ?? "",
//         supervisorQualityScore: saved.supervisorQualityScore ?? "",
//         supervisorComments: saved.supervisorComments || "",
//       };
//     });

//     return [{
//       month: responseMonth || existingMonth.month || appraisalData.appraisalPeriod || "Current Month",
//       majorGoals,
//       otherGoals,
//     }];
//   };

//   const monthData = useMemo(() => editedData.section2 || [], [editedData.section2]);

//   /* ================= CALCULATIONS ================= */
//   const section2SupervisorTotal = useMemo(() => {
//     return (editedData.section2 || []).reduce((acc, month) => {
//       const majorValid = (month.majorGoals || []).filter(g =>
//         !isNaN(Number(g.supervisorActionScore)) && !isNaN(Number(g.supervisorQualityScore))
//       );
//       const otherValid = (month.otherGoals || []).filter(g =>
//         !isNaN(Number(g.supervisorActionScore)) && !isNaN(Number(g.supervisorQualityScore))
//       );

//       const majorSum = majorValid.reduce((sum, g) =>
//         sum + ((Number(g.supervisorActionScore) + Number(g.supervisorQualityScore)) / 2), 0
//       );
//       const otherSum = otherValid.reduce((sum, g) =>
//         sum + ((Number(g.supervisorActionScore) + Number(g.supervisorQualityScore)) / 2), 0
//       );

//       const majorTotal = majorValid.length ? ((majorSum / majorValid.length) / 5) * 55 : 0;
//       const otherTotal = otherValid.length ? ((otherSum / otherValid.length) / 5) * 15 : 0;

//       return acc + majorTotal + otherTotal;
//     }, 0);
//   }, [editedData.section2]);

//   const section3SupervisorTotal = useMemo(() => {
//     const items = editedData.section3 || [];
//     const valid = items.filter(x => !isNaN(Number(x.supervisorScore)));
//     const sum = valid.reduce((acc, item) => acc + Number(item.supervisorScore), 0);
//     return valid.length ? (sum / valid.length / 5) * 20 : 0;
//   }, [editedData.section3]);

//   const section4SupervisorTotal = useMemo(() => {
//     const items = editedData.section4 || [];
//     const valid = items.filter(x => !isNaN(Number(x.supervisorScore)));
//     const sum = valid.reduce((acc, item) => acc + Number(item.supervisorScore), 0);
//     return valid.length ? (sum / valid.length / 5) * 10 : 0;
//   }, [editedData.section4]);

//   const computedSupervisorCumulative = useMemo(() => {
//     return section2SupervisorTotal + section3SupervisorTotal + section4SupervisorTotal;
//   }, [section2SupervisorTotal, section3SupervisorTotal, section4SupervisorTotal]);

//   useEffect(() => {
//     setEditedData((prev) => ({
//       ...prev,
//       summary: {
//         ...prev.summary,
//         supervisorCumulative: Number(computedSupervisorCumulative.toFixed(2)),
//         supervisorGrade: gradeFromScore(computedSupervisorCumulative),
//       },
//     }));
//   }, [computedSupervisorCumulative]);

//   /* ================= HANDLERS ================= */
//   const handleSection2Change = (monthIndex, goalType, goalIndex, field, value) => {
//     setEditedData((prev) => {
//       const next = [...prev.section2];
//       const month = { ...next[monthIndex] };
//       const goalsList = [...(month[goalType] || [])];
//       goalsList[goalIndex] = { ...goalsList[goalIndex], [field]: value };
//       month[goalType] = goalsList;
//       next[monthIndex] = month;
//       return { ...prev, section2: next };
//     });
//   };

//   const handleSectionChange = (section, index, field, value) => {
//     setEditedData((prev) => {
//       const next = [...(prev[section] || [])];
//       next[index] = { ...next[index], [field]: value };
//       return { ...prev, [section]: next };
//     });
//   };

//   const handleSummaryChange = (field, value) => {
//     setEditedData((prev) => ({
//       ...prev,
//       summary: { ...prev.summary, [field]: value },
//     }));
//   };

//   const handleOverallCommentsChange = (value) => {
//     setEditedData((prev) => ({
//       ...prev,
//       staffFeedback: { ...prev.staffFeedback, supervisorAttention: value },
//     }));
//   };

//   const handleSave = async () => {
//     try {
//       setSaving(true);
//       setError(null);
//       setSuccess("");

//       await api.put(`/appraisal/supervisor-score/${appraisalId}`, {
//         section2: editedData.section2,
//         section3: editedData.section3,
//         section4: editedData.section4,
//         summary: {
//           supervisorCumulative: editedData.summary.supervisorCumulative,
//           supervisorGrade: editedData.summary.supervisorGrade,
//           supervisorOverallComments: editedData.summary.supervisorOverallComments || "",
//         },
//         staffFeedback: editedData.staffFeedback,
//       });

//       setSuccess("Appraisal updated successfully!");
//       setTimeout(() => navigate("/supervisor/dashboard"), 1500);
//     } catch (err) {
//       console.error(err);
//       setError(err.response?.data?.message || "Failed to save changes");
//     } finally {
//       setSaving(false);
//     }
//   };

//   if (loading) return <Container $collapsed={collapsed}><NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} /><Main><InfoMessage>Loading appraisal...</InfoMessage></Main><Footer /></Container>;
//   if (error) return <Container $collapsed={collapsed}><NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} /><Main><InfoMessage style={{ color: "red" }}>Error: {error}</InfoMessage></Main><Footer /></Container>;
//   if (!appraisal) return <Container $collapsed={collapsed}><NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} /><Main><InfoMessage>Appraisal not found</InfoMessage></Main><Footer /></Container>;

//   return (
//     <Container $collapsed={collapsed}>
//       <NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} />

//       <Main>
//         <PageHeader>
//           <div>
//             <Title>Supervisor's Assessment</Title>
//             <Subtitle>
//               Review full appraisal for {appraisal.userDetails?.username || "Staff"} — only supervisor fields are editable
//             </Subtitle>
//           </div>
//         </PageHeader>

//         <DocumentCard>
//           <DocumentTop>
//             <DocTitle>{appraisal.userDetails?.username || "Staff"}</DocTitle>
//             <PeriodRow>
//               <Pill>{appraisal.appraisalPeriod}</Pill>
//             </PeriodRow>
//           </DocumentTop>

//           {/* =======================================================
//               SECTION 2: PERFORMANCE ON GOALS
//               ======================================================= */}
//           <SectionBlock>
//             <SectionHeading>
//               <SectionTitle>PERFORMANCE ON GOALS</SectionTitle>
//             </SectionHeading>

//             {monthData.map((monthEntry, mIndex) => (
//               <div key={mIndex} style={{ marginBottom: "48px" }}>
//                 <SectionTitle style={{ marginBottom: 16, fontSize: "21px", color: "#1e40af" }}>
//                   Performance for {formatValue(monthEntry.month)}
//                 </SectionTitle>

//                 {/* --- MAJOR GOALS TABLE --- */}
//                 <SectionHeader>
//                   <SecTitle>Major Goals</SecTitle>
//                 </SectionHeader>

//                 <TableWrapper>
//                   <Table>
//                     <thead>
//                       <tr>
//                         <Th style={{ width: "20%" }}>Goals</Th>
//                         <Th style={{ width: "22%" }}>Achievements</Th>
//                         <Th style={{ width: "7%" }}>Staff Action</Th>
//                         <Th style={{ width: "7%" }}>Staff Quality</Th>
//                         <Th style={{ width: "8%" }}>Sup. Action</Th>
//                         <Th style={{ width: "8%" }}>Sup. Quality</Th>
//                         <Th style={{ width: "28%" }}>Comments</Th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {(monthEntry.majorGoals || []).map((goal, gIndex) => {
//                         const weeks = goal.weekly || [];
//                         const rowSpanCount = weeks.length > 0 ? weeks.length + 1 : 1;

//                         return (
//                           <React.Fragment key={goal.goalId || `major-${gIndex}`}>
//                             <tr>
//                               <Td style={rowSpanCount > 1 ? { borderBottom: "none", paddingBottom: "6px" } : {}}>
//                                 <MonthlyHeader>
//                                   <ExpandableText text={goal.goal} limit={85} />
//                                   {goal.unit && <UnitBadge style={{ marginTop: "6px" }}>{goal.unit}</UnitBadge>}
//                                   <GoalDate>
//                                     {formatNiceDate(goal.startDate)} - {formatNiceDate(goal.deliveryDate)}
//                                   </GoalDate>
//                                 </MonthlyHeader>
//                               </Td>

//                               <Td style={rowSpanCount > 1 ? { borderBottom: "none", paddingBottom: "6px" } : {}}>
//                                 <DisabledInput style={{ minHeight: "90px", background: "#fff" }}>
//                                   <strong>Monthly Achievement:</strong><br />
//                                   <ExpandableText text={goal.achievement || "No monthly achievement submitted."} limit={120} />
//                                 </DisabledInput>
//                               </Td>

//                               <Td rowSpan={rowSpanCount}><SmallScore>{scoreValue(goal.staffActionScore)}</SmallScore></Td>
//                               <Td rowSpan={rowSpanCount}><SmallScore>{scoreValue(goal.staffQualityScore)}</SmallScore></Td>

//                               <Td rowSpan={rowSpanCount}>
//                                 <EditableScore
//                                   type="number" min="0" max="5" step="0.1"
//                                   value={goal.supervisorActionScore ?? ""}
//                                   onChange={(e) => handleSection2Change(mIndex, "majorGoals", gIndex, "supervisorActionScore", e.target.value)}
//                                 />
//                               </Td>
//                               <Td rowSpan={rowSpanCount}>
//                                 <EditableScore
//                                   type="number" min="0" max="5" step="0.1"
//                                   value={goal.supervisorQualityScore ?? ""}
//                                   onChange={(e) => handleSection2Change(mIndex, "majorGoals", gIndex, "supervisorQualityScore", e.target.value)}
//                                 />
//                               </Td>

//                               <Td rowSpan={rowSpanCount}>
//                                 <CommentLabel $color="#ef4444">Staff Comment</CommentLabel>
//                                 <DisabledInput style={{ background: "white", padding: "8px", minHeight: "40px" }}>
//                                   {goal.staffComment || "No staff comment"}
//                                 </DisabledInput>

//                                 <CommentLabel $color="#0f172a" $marginTop="12px">Supervisor's Comment</CommentLabel>
//                                 <EditableText
//                                   value={goal.supervisorComments || ""}
//                                   onChange={(e) => handleSection2Change(mIndex, "majorGoals", gIndex, "supervisorComments", e.target.value)}
//                                   placeholder="Enter supervisor comment..."
//                                 />
//                               </Td>
//                             </tr>

//                             {/* WEEKLY ROWS */}
//                             {weeks.map((week, index) => {
//                               const isLast = index === weeks.length - 1;
//                               const cellStyle = {
//                                 borderBottom: isLast ? undefined : "none",
//                                 borderRight: "1px solid #e2e8f0", 
//                                 paddingTop: "6px", paddingBottom: isLast ? undefined : "6px"
//                               };
//                               const wWeek = week.week || `Week ${index + 1}`;
                              
//                               return (
//                                 <tr key={`week-${index}`}>
//                                   <Td style={cellStyle}>
//                                     <WeekGoalBox>
//                                       <strong>{wWeek} Goal</strong>
//                                       <div style={{ marginTop: "6px" }}>
//                                         <ExpandableText text={week.weeklyGoal || week.goal} limit={70} isWeekly={true} />
//                                       </div>
//                                     </WeekGoalBox>
//                                   </Td>
//                                   <Td style={cellStyle}>
//                                     <WeekAchBox>
//                                       <strong>{wWeek} Achievement</strong>
//                                       <div style={{ marginTop: "6px" }}>
//                                         {(week.weeklyAchievement || week.achievements)?.trim() 
//                                           ? (week.weeklyAchievement || week.achievements) 
//                                           : "No achievement submitted."}
//                                       </div>
//                                     </WeekAchBox>
//                                   </Td>
//                                 </tr>
//                               );
//                             })}
//                           </React.Fragment>
//                         );
//                       })}
//                     </tbody>
//                   </Table>
//                 </TableWrapper>

//                 {/* --- OTHER GOALS TABLE --- */}
//                 <SectionHeader>
//                   <SecTitle>Other Goals</SecTitle>
//                 </SectionHeader>

//                 <TableWrapper>
//                   <Table>
//                     <thead>
//                       <tr>
//                         <Th style={{ width: "20%" }}>Goals</Th>
//                         <Th style={{ width: "22%" }}>Achievements</Th>
//                         <Th style={{ width: "7%" }}>Staff Action</Th>
//                         <Th style={{ width: "7%" }}>Staff Quality</Th>
//                         <Th style={{ width: "8%" }}>Sup. Action</Th>
//                         <Th style={{ width: "8%" }}>Sup. Quality</Th>
//                         <Th style={{ width: "28%" }}>Comments</Th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {(monthEntry.otherGoals || []).map((goal, gIndex) => (
//                         <tr key={goal.goalId || `other-${gIndex}`}>
//                           <Td>
//                             <RoutineHeader>
//                               <ExpandableText text={goal.goal} limit={85} />
//                               {goal.unit && <UnitBadge>{goal.unit}</UnitBadge>}
//                               <GoalDate>Due {formatNiceDate(goal.deliveryDate)}</GoalDate>
//                             </RoutineHeader>
//                           </Td>
//                           <Td>
//                             <DisabledInput style={{ background: "#fff" }}>
//                                <ExpandableText text={goal.achievement || "No achievement submitted."} limit={120} />
//                             </DisabledInput>
//                           </Td>
//                           <Td><SmallScore>{scoreValue(goal.staffActionScore)}</SmallScore></Td>
//                           <Td><SmallScore>{scoreValue(goal.staffQualityScore)}</SmallScore></Td>
//                           <Td>
//                             <EditableScore
//                               type="number" min="0" max="5" step="0.1"
//                               value={goal.supervisorActionScore ?? ""}
//                               onChange={(e) => handleSection2Change(mIndex, "otherGoals", gIndex, "supervisorActionScore", e.target.value)}
//                             />
//                           </Td>
//                           <Td>
//                             <EditableScore
//                               type="number" min="0" max="5" step="0.1"
//                               value={goal.supervisorQualityScore ?? ""}
//                               onChange={(e) => handleSection2Change(mIndex, "otherGoals", gIndex, "supervisorQualityScore", e.target.value)}
//                             />
//                           </Td>
//                           <Td>
//                             <CommentLabel $color="#ef4444">Staff Comment</CommentLabel>
//                             <DisabledInput style={{ background: "white", padding: "8px", minHeight: "40px" }}>
//                               {goal.staffComment || "No staff comment"}
//                             </DisabledInput>

//                             <CommentLabel $color="#0f172a" $marginTop="12px">Supervisor's Comment</CommentLabel>
//                             <EditableText
//                               value={goal.supervisorComments || ""}
//                               onChange={(e) => handleSection2Change(mIndex, "otherGoals", gIndex, "supervisorComments", e.target.value)}
//                               placeholder="Enter supervisor comment..."
//                             />
//                           </Td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </Table>
//                 </TableWrapper>

//                 {/* --- MOBILE VIEW --- */}
//                 <MobileGrid>
//                    {(monthEntry.majorGoals || []).map((goal, gIndex) => {
//                      const weeks = goal.weekly || [];
//                      return (
//                        <MobileCard key={goal.goalId || `mob-major-${gIndex}`} $isRoutine={false}>
//                           <MobileTop>
//                             <MobilePill $isRoutine={false}>Major Goal</MobilePill>
//                           </MobileTop>
//                           <div style={{fontWeight: "800", color: "#0f172a", marginBottom: "4px", fontSize: "14px"}}>
//                             <ExpandableText text={goal.goal} limit={90} />
//                           </div>
//                           <MobileDate>{formatNiceDate(goal.startDate)} - {formatNiceDate(goal.deliveryDate)}</MobileDate>

//                           <MobileLabel>Monthly Achievement</MobileLabel>
//                           <DisabledInput style={{ background: "#fff", marginBottom: "12px" }}>
//                             {goal.achievement || "No monthly achievement submitted."}
//                           </DisabledInput>

//                           {/* Mobile Weekly Goals */}
//                           {weeks.length > 0 && (
//                             <div style={{ marginTop: "12px", display: "flex", flexDirection: "column", gap: "10px", marginBottom: "16px" }}>
//                               {weeks.map((w, wIdx) => {
//                                 const wWeek = w.week || `Week ${wIdx + 1}`;
//                                 return (
//                                   <div key={wIdx} style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px", border: "1px solid #e2e8f0" }}>
//                                     <div style={{ color: "#ef4444", fontWeight: "700", fontSize: "12px" }}>{wWeek} Goal</div>
//                                     <div style={{ fontSize: "13px", marginTop: "4px" }}>{w.weeklyGoal || w.goal}</div>
//                                     <div style={{ color: "#16a34a", fontWeight: "700", fontSize: "12px", marginTop: "10px" }}>{wWeek} Achievement</div>
//                                     <div style={{ fontSize: "13px", marginTop: "4px" }}>{(w.weeklyAchievement || w.achievements) || "None"}</div>
//                                   </div>
//                                 )
//                               })}
//                             </div>
//                           )}

//                           <MobileLabel>Staff Scores</MobileLabel>
//                           <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
//                             <SmallScore>A: {scoreValue(goal.staffActionScore)}</SmallScore>
//                             <SmallScore>Q: {scoreValue(goal.staffQualityScore)}</SmallScore>
//                           </div>

//                           <MobileLabel>Staff Comment</MobileLabel>
//                           <DisabledInput style={{ marginBottom: "10px", background: "white" }}>
//                             {goal.staffComment || "No comment."}
//                           </DisabledInput>

//                           <MobileLabel>Supervisor Action Score</MobileLabel>
//                           <EditableScore type="number" min="0" max="5" step="0.1" value={goal.supervisorActionScore ?? ""} onChange={(e) => handleSection2Change(mIndex, "majorGoals", gIndex, "supervisorActionScore", e.target.value)} />
                          
//                           <MobileLabel>Supervisor Quality Score</MobileLabel>
//                           <EditableScore type="number" min="0" max="5" step="0.1" value={goal.supervisorQualityScore ?? ""} onChange={(e) => handleSection2Change(mIndex, "majorGoals", gIndex, "supervisorQualityScore", e.target.value)} />
                          
//                           <MobileLabel>Supervisor Comment</MobileLabel>
//                           <EditableText value={goal.supervisorComments || ""} onChange={(e) => handleSection2Change(mIndex, "majorGoals", gIndex, "supervisorComments", e.target.value)} />
//                        </MobileCard>
//                      )
//                    })}

//                    {(monthEntry.otherGoals || []).map((goal, gIndex) => (
//                      <MobileCard key={goal.goalId || `mob-other-${gIndex}`} $isRoutine={true}>
//                           <MobileTop>
//                             <MobilePill $isRoutine={true}>Other Goal</MobilePill>
//                           </MobileTop>
//                           <div style={{fontWeight: "800", color: "#0f172a", marginBottom: "4px", fontSize: "14px"}}>
//                             <ExpandableText text={goal.goal} limit={90} />
//                           </div>
//                           <MobileDate>Due {formatNiceDate(goal.deliveryDate)}</MobileDate>

//                           <MobileLabel>Achievement</MobileLabel>
//                           <DisabledInput style={{ background: "#fff", marginBottom: "12px" }}>
//                             {goal.achievement || "No achievement submitted."}
//                           </DisabledInput>

//                           <MobileLabel>Staff Scores</MobileLabel>
//                           <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
//                             <SmallScore>A: {scoreValue(goal.staffActionScore)}</SmallScore>
//                             <SmallScore>Q: {scoreValue(goal.staffQualityScore)}</SmallScore>
//                           </div>

//                           <MobileLabel>Staff Comment</MobileLabel>
//                           <DisabledInput style={{ marginBottom: "10px", background: "white" }}>
//                             {goal.staffComment || "No comment."}
//                           </DisabledInput>

//                           <MobileLabel>Supervisor Action Score</MobileLabel>
//                           <EditableScore type="number" min="0" max="5" step="0.1" value={goal.supervisorActionScore ?? ""} onChange={(e) => handleSection2Change(mIndex, "otherGoals", gIndex, "supervisorActionScore", e.target.value)} />
                          
//                           <MobileLabel>Supervisor Quality Score</MobileLabel>
//                           <EditableScore type="number" min="0" max="5" step="0.1" value={goal.supervisorQualityScore ?? ""} onChange={(e) => handleSection2Change(mIndex, "otherGoals", gIndex, "supervisorQualityScore", e.target.value)} />
                          
//                           <MobileLabel>Supervisor Comment</MobileLabel>
//                           <EditableText value={goal.supervisorComments || ""} onChange={(e) => handleSection2Change(mIndex, "otherGoals", gIndex, "supervisorComments", e.target.value)} />
//                        </MobileCard>
//                    ))}
//                 </MobileGrid>
//               </div>
//             ))}
//           </SectionBlock>

//           <SectionBlock>
//             <SectionHeading>
//               <SectionTitle>WORK ETHIC & LEADERSHIP</SectionTitle>
//               <SectionSub>Staff scores remain visible, supervisor scores editable</SectionSub>
//             </SectionHeading>
//             <TableWrap>
//               <LegacyTable>
//                 <thead>
//                   <tr>
//                     <th>S/N</th>
//                     <th>ATTRIBUTE</th>
//                     <th>DESCRIPTION</th>
//                     <th>STAFF SCORE</th>
//                     <th>STAFF COMMENTS</th>
//                     <th>SUPERVISOR SCORE</th>
//                     <th>SUPERVISOR COMMENTS</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {(editedData.section3 || []).map((item, index) => (
//                     <tr key={index}>
//                       <td>{index + 1}</td>
//                       <td><DisabledInput>{formatValue(item.attribute)}</DisabledInput></td>
//                       <td><DisabledInput>{formatValue(item.description)}</DisabledInput></td>
//                       <td><SmallScore>{scoreValue(item.staffScore)}</SmallScore></td>
//                       <td><DisabledInput>{formatValue(item.staffComments)}</DisabledInput></td>
//                       <td>
//                         <EditableScore
//                           type="number" min="0" max="5" step="0.1"
//                           value={item.supervisorScore ?? ""}
//                           onChange={(e) => handleSectionChange("section3", index, "supervisorScore", e.target.value)}
//                         />
//                       </td>
//                       <td>
//                         <EditableText
//                           value={item.supervisorComments || ""}
//                           onChange={(e) => handleSectionChange("section3", index, "supervisorComments", e.target.value)}
//                         />
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </LegacyTable>
//             </TableWrap>
//           </SectionBlock>

//           <SectionBlock>
//             <SectionHeading>
//               <SectionTitle>COMPLIANCE</SectionTitle>
//               <SectionSub>Staff scores remain visible, supervisor scores editable</SectionSub>
//             </SectionHeading>
//             <TableWrap>
//               <LegacyTable>
//                 <thead>
//                   <tr>
//                     <th>S/N</th>
//                     <th>PROTOCOL</th>
//                     <th>DESCRIPTION</th>
//                     <th>STAFF SCORE</th>
//                     <th>STAFF COMMENTS</th>
//                     <th>SUPERVISOR SCORE</th>
//                     <th>SUPERVISOR COMMENTS</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {(editedData.section4 || []).map((item, index) => (
//                     <tr key={index}>
//                       <td>{index + 1}</td>
//                       <td><DisabledInput>{formatValue(item.attribute)}</DisabledInput></td>
//                       <td><DisabledInput>{formatValue(item.description)}</DisabledInput></td>
//                       <td><SmallScore>{scoreValue(item.staffScore)}</SmallScore></td>
//                       <td><DisabledInput>{formatValue(item.staffComments)}</DisabledInput></td>
//                       <td>
//                         <EditableScore
//                           type="number" min="0" max="5" step="0.1"
//                           value={item.supervisorScore ?? ""}
//                           onChange={(e) => handleSectionChange("section4", index, "supervisorScore", e.target.value)}
//                         />
//                       </td>
//                       <td>
//                         <EditableText
//                           value={item.supervisorComments || ""}
//                           onChange={(e) => handleSectionChange("section4", index, "supervisorComments", e.target.value)}
//                         />
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </LegacyTable>
//             </TableWrap>
//           </SectionBlock>

//           {/* =======================================================
//               SUMMARY OF PERFORMANCE (SIDE-BY-SIDE REDESIGN)
//               ======================================================= */}
//           <SectionBlock>
//             <SectionHeading>
//               <SectionTitle>SUMMARY OF PERFORMANCE</SectionTitle>
//               <SectionSub>Staff summary remains visible, supervisor summary auto-calculates</SectionSub>
//             </SectionHeading>

//             {/* Citation full width */}
//             <SummaryCard style={{ marginBottom: "24px" }}>
//               <CardTitle>500 Character Citation</CardTitle>
//               <TextBlock>{formatValue(editedData.summary?.citation)}</TextBlock>
//             </SummaryCard>

//             <SummaryGrid>
//               {/* --- LEFT COLUMN: STAFF TOTALS --- */}
//               <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
//                 <SummaryCard>
//                   <CardTitle>Staff Score Breakdown</CardTitle>
//                   <ScoreList>
//                     <ScoreRow variant="staff">
//                       <span>Goals</span>
//                       <strong>{formatValue(editedData.summary?.section2, 0)}</strong>
//                     </ScoreRow>
//                     <ScoreRow variant="staff">
//                       <span>Ethics</span>
//                       <strong>{formatValue(editedData.summary?.section3, 0)}</strong>
//                     </ScoreRow>
//                     <ScoreRow variant="staff">
//                       <span>Compliance</span>
//                       <strong>{formatValue(editedData.summary?.section4, 0)}</strong>
//                     </ScoreRow>
//                     <ScoreRow variant="staff" style={{ borderTop: "2px solid #bfdbfe", paddingTop: "14px", marginTop: "6px" }}>
//                       <span>Staff Cumulative</span>
//                       <strong style={{ fontSize: "1.1rem" }}>{formatValue(editedData.summary?.cumulative, 0)}</strong>
//                     </ScoreRow>
//                   </ScoreList>
//                 </SummaryCard>
//                 <SummaryCard style={{ alignItems: "center", textAlign: "center" }}>
//                   <div style={{ fontSize: 13, fontWeight: 800, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "8px" }}>Staff Grade</div>
//                   <BigGrade>{formatValue(editedData.summary?.grade, "—")}</BigGrade>
//                 </SummaryCard>
//               </div>

//               {/* --- RIGHT COLUMN: SUPERVISOR TOTALS --- */}
//               <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
//                 <SummaryCard>
//                   <CardTitle>Supervisor Score Breakdown</CardTitle>
//                   <ScoreList>
//                     <ScoreRow variant="supervisor">
//                       <span>Goals</span>
//                       <strong>{Number(section2SupervisorTotal || 0).toFixed(1)}</strong>
//                     </ScoreRow>
//                     <ScoreRow variant="supervisor">
//                       <span>Ethics</span>
//                       <strong>{Number(section3SupervisorTotal || 0).toFixed(1)}</strong>
//                     </ScoreRow>
//                     <ScoreRow variant="supervisor">
//                       <span>Compliance</span>
//                       <strong>{Number(section4SupervisorTotal || 0).toFixed(1)}</strong>
//                     </ScoreRow>
//                     <ScoreRow variant="supervisor" style={{ borderTop: "2px solid #bbf7d0", paddingTop: "14px", marginTop: "6px" }}>
//                       <span>Supervisor Cumulative</span>
//                       <strong style={{ fontSize: "1.1rem" }}>{Number(computedSupervisorCumulative || 0).toFixed(1)}</strong>
//                     </ScoreRow>
//                   </ScoreList>
//                 </SummaryCard>
//                 <SummaryCard style={{ alignItems: "center", textAlign: "center" }}>
//                   <div style={{ fontSize: 13, fontWeight: 800, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "8px" }}>Supervisor Grade</div>
//                   <BigGrade style={{ color: "#0f766e" }}>{gradeFromScore(computedSupervisorCumulative)}</BigGrade>
//                 </SummaryCard>
//               </div>
//             </SummaryGrid>
            
//             {/* Kept manual inputs as hidden/developer tools or just rendering them visually hidden so state logic remains perfectly untouched if needed */}
//             <div style={{ display: "none" }}>
//               <EditableScore
//                 type="number"
//                 value={editedData.summary?.supervisorCumulative ?? ""}
//                 onChange={(e) => handleSummaryChange("supervisorCumulative", e.target.value)}
//               />
//               <EditableText
//                 value={editedData.summary?.supervisorGrade || ""}
//                 onChange={(e) => handleSummaryChange("supervisorGrade", e.target.value)}
//               />
//             </div>
//           </SectionBlock>

//           <SectionBlock>
//             <SectionHeading>
//               <SectionTitle>SUPERVISOR’S OVERALL COMMENTS</SectionTitle>
//               <SectionSub>Editable by supervisor</SectionSub>
//             </SectionHeading>
//             <EditableText
//               style={{ minHeight: "120px" }}
//               value={editedData.staffFeedback?.supervisorAttention || ""}
//               onChange={(e) => handleOverallCommentsChange(e.target.value)}
//               placeholder="Enter your final overall comments and feedback here..."
//             />
//           </SectionBlock>

//           <SectionBlock>
//             <SectionHeading>
//               <SectionTitle>HEAD OF DEPARTMENT’S OVERALL COMMENTS</SectionTitle>
//               <SectionSub>Read only for now</SectionSub>
//             </SectionHeading>
//             <TextBlock>{formatValue(editedData.summary?.hodOverallComments)}</TextBlock>
//           </SectionBlock>

//           <SaveButton onClick={handleSave} disabled={saving}>
//             {saving ? "Saving Changes..." : "Save Supervisor Assessment"}
//           </SaveButton>

//           {success && <p style={{ color: "green", fontWeight: 600 }}>{success}</p>}
//           {error && <p style={{ color: "red", fontWeight: 600 }}>{error}</p>}
//         </DocumentCard>
//       </Main>
//       <Footer />
//     </Container>
//   );
// };

// export default SupervisorAppraisalForm;










import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import NavBarSuper from "./NavBarSuper";
import Footer from "./Footer";
import api from "../api";
import { useParams, useNavigate, useLocation } from "react-router-dom";

/* ================= HELPERS ================= */
const formatValue = (value, fallback = "—") => {
  if (value === null || value === undefined || value === "") return fallback;
  return value;
};

const scoreValue = (value) => {
  if (value === null || value === undefined || value === "") return "—";
  return value;
};

const gradeFromScore = (score) => {
  const s = Number(score || 0);
  if (s >= 90) return "A";
  if (s >= 80) return "B";
  if (s >= 70) return "C";
  if (s >= 60) return "D";
  return "E";
};

const getWeekOfMonth = (dateString) => {
  if (!dateString) return "Week 1";
  const d = new Date(dateString);
  const firstDay = new Date(d.getFullYear(), d.getMonth(), 1).getDay();
  return `Week ${Math.ceil((d.getDate() + firstDay) / 7)}`;
};

const formatNiceDate = (dateString) => {
  if (!dateString) return "—";
  return new Date(dateString).toDateString();
};

const getGoalUnit = (goal) => {
  return goal.unit || goal.subDepartment || "General Unit";
};

// 🔥 NEW HELPER: Converts "April 2026" to "2026-04" for the backend
const formatToYearMonth = (periodString) => {
  if (!periodString) return "";
  const d = new Date(periodString);
  if (isNaN(d.getTime())) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  return `${y}-${m}`;
};

/* ================= SHARED COMPONENTS ================= */
const ExpandableText = ({ text, limit = 90, isWeekly = false }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  if (!text) return null;

  const textStyle = {
    maxWidth: "350px",
    wordWrap: "break-word",
    marginTop: isWeekly ? "4px" : "10px",
    fontWeight: isWeekly ? "600" : "700",
    color: "#0f172a",
    fontSize: isWeekly ? "13px" : "14px",
    lineHeight: "1.5",
  };

  if (String(text).length <= limit) {
    return <div style={textStyle}>{text}</div>;
  }

  return (
    <div style={{ ...textStyle, display: "block" }}>
      <span style={{ display: "inline" }}>
        {isExpanded ? text : `${String(text).substring(0, limit)}...`}
      </span>
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          setIsExpanded(!isExpanded);
        }}
        style={{
          background: "none", border: "none", color: "#2563eb",
          cursor: "pointer", fontSize: "12px", fontWeight: "800",
          padding: "0 0 0 6px", textDecoration: "underline",
        }}
      >
        {isExpanded ? "Show less" : "Read more"}
      </button>
    </div>
  );
};

/* ================= LAYOUT STYLES ================= */
const Container = styled.div`
  --page-bg: linear-gradient(180deg, #f8fafc 0%, #edf4ff 100%);
  min-height: 100vh; background: var(--page-bg); margin-left: 0;
`;

const Main = styled.main`
  width: min(1450px, calc(100% - 32px)); margin: 0 auto; padding: 90px 0 60px;
  @media (max-width: 1024px) { width: min(100%, calc(100% - 24px)); padding: 84px 0 40px; }
  @media (max-width: 576px) { width: min(100%, calc(100% - 16px)); padding: 80px 0 28px; }
`;

const TableWrap = styled.div`
  overflow-x: auto;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  margin-bottom: 18px;

  @media (max-width: 900px) { display: none; }
`;

const PageHeader = styled.div`
  display: flex; justify-content: space-between; align-items: flex-end;
  gap: 16px; flex-wrap: wrap; margin-bottom: 24px;
`;

const Title = styled.h1`
  font-size: clamp(1.6rem, 1.2rem + 1vw, 2.1rem); font-weight: 800; color: #0f172a; margin: 0 0 6px;
`;

const Subtitle = styled.p`
  color: #64748b; font-size: 15px; margin: 0; line-height: 1.6;
`;

const DocumentCard = styled.div`
  background: white; border-radius: 24px; padding: 24px;
  box-shadow: 0 22px 55px rgba(15, 23, 42, 0.08); border: 1px solid #e8eef7;
  @media (max-width: 576px) { padding: 16px; border-radius: 20px; }
`;

const DocumentTop = styled.div`
  border-bottom: 2px solid #e2e8f0; padding-bottom: 18px; margin-bottom: 22px;
`;

const DocTitle = styled.h2`
  font-size: clamp(1.3rem, 1.1rem + 0.6vw, 1.7rem); font-weight: 800; color: #0f172a; margin: 0 0 10px;
`;

const PeriodRow = styled.div`
  display: flex; flex-wrap: wrap; gap: 12px;
`;

const Pill = styled.div`
  display: inline-flex; align-items: center; padding: 8px 12px;
  background: ${(props) => props.bg || "#eff6ff"};
  color: ${(props) => props.color || "#1d4ed8"};
  border-radius: 999px; font-size: 13px; font-weight: 700;
`;

const SectionBlock = styled.section`
  margin-top: 28px;
`;

const SectionHeading = styled.div`
  background: linear-gradient(135deg, #0f172a, #1d4ed8);
  color: white; border-radius: 16px; padding: 14px 18px; margin-bottom: 16px;
`;

const SectionTitle = styled.h3`
  font-size: 18px; font-weight: 800; margin: 0 0 4px;
`;

const SectionSub = styled.p`
  font-size: 13px; margin: 0; opacity: 0.9;
`;

const SectionHeader = styled.div`
  margin-bottom: 18px;
`;

const SecTitle = styled.h2`
  margin: 0; font-size: clamp(1.2rem, 1rem + 0.7vw, 1.7rem); font-weight: 800;
`;

const TableWrapper = styled.div`
  width: 100%; overflow-x: auto; border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.14); margin-bottom: 24px;
  @media (max-width: 1024px) { display: none; }
`;

const Table = styled.table`
  width: 100%; border-collapse: collapse; background: white; table-layout: fixed;
`;

const Th = styled.th`
  background: #fef2f2; padding: 12px 10px; text-align: left;
  font-size: 12px; font-weight: 800; color: #7f1d1d;
  border-bottom: 2px solid #e2e8f0; border-right: 1px solid #e2e8f0; border-left: 1px solid #e2e8f0;
  vertical-align: middle; line-height: 1.3;
  &:first-child { border-left: none; }
  &:last-child { border-right: none; }
`;

const Td = styled.td`
  padding: 10px 8px; border-bottom: 1px solid #e2e8f0; border-right: 1px solid #e2e8f0;
  border-left: 1px solid #e2e8f0; vertical-align: top;
  font-size: 13px; color: #1e293b; white-space: normal; word-break: break-word;
  overflow-wrap: anywhere; line-height: 1.4;
  &:first-child { border-left: none; }
  &:last-child { border-right: none; }
`;

const MonthlyHeader = styled.div`
  background: #fef2f2; padding: 12px 14px; border-left: 4px solid #ef4444; border-radius: 8px; height: 100%; box-sizing: border-box;
`;

const RoutineHeader = styled(MonthlyHeader)`
  background: #fff7ed; border-left-color: #ea580c;
`;

const WeekGoalBox = styled.div`
  padding: 12px; border-left: 3px solid #ef4444; background: #fdf2f2; border-radius: 6px; font-size: 12px; color: #334155; word-wrap: break-word; height: 100%; box-sizing: border-box;
`;

const WeekAchBox = styled.div`
  padding: 12px; border-left: 3px solid #16a34a; background: #f0fdf4; border-radius: 6px; font-size: 12px; color: #334155; line-height: 1.5; word-break: break-word; height: 100%; box-sizing: border-box;
`;

const GoalDate = styled.div`
  font-size: 11px; margin-top: 7px; color: #64748b;
`;

const UnitBadge = styled.span`
  display: inline-block; margin-top: 6px; padding: 4px 10px; background: #e0f2fe; color: #0369a1; border: 1px solid #bae6fd; border-radius: 6px; font-size: 11px; font-weight: 800; letter-spacing: 0.05em; text-transform: uppercase;
`;

const CommentLabel = styled.div`
  font-size: 10px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em;
  color: ${({ $color }) => $color || "#64748b"}; margin-bottom: 4px; margin-top: ${({ $marginTop }) => $marginTop || "0"};
`;
const MobileDate = styled.div`
  font-size: 12px;
  color: #64748b;
`;

/* Mobile Styles */
const MobileGrid = styled.div`
  display: none;
  @media (max-width: 1024px) { display: grid; gap: 16px; margin-bottom: 24px; }
`;

const MobileCard = styled.div`
  background: white; border: 1px solid rgba(148, 163, 184, 0.14);
  border-left: 5px solid ${({ $isRoutine }) => ($isRoutine ? "#ea580c" : "#ef4444")};
  border-radius: 16px; padding: 16px; box-shadow: 0 4px 16px rgba(15, 23, 42, 0.05); display: flex; flex-direction: column; min-width: 0;
`;

const MobileTop = styled.div`
  display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 8px;
`;

const MobilePill = styled.div`
  display: inline-flex; align-items: center; padding: 4px 10px; border-radius: 999px; font-size: 11px; font-weight: 800; letter-spacing: 0.04em; text-transform: uppercase;
  background: ${({ $isRoutine }) => $isRoutine ? "rgba(234,88,12,0.12)" : "rgba(220, 38, 38, 0.12)"};
  color: ${({ $isRoutine }) => ($isRoutine ? "#c2410c" : "#b91c1c")};
`;

const MobileTitle = styled.div`
  font-size: 14px; font-weight: 800; color: #0f172a; line-height: 1.4; margin-bottom: 4px; word-wrap: break-word; overflow-wrap: anywhere;
`;

const MobileLabel = styled.div`
  font-size: 11px; font-weight: 800; margin-top: 16px; margin-bottom: 6px; color: #64748b; text-transform: uppercase; letter-spacing: 0.04em;
`;

const DisabledInput = styled.div`
  min-height: 42px; border: 1px solid #e2e8f0; background: #f8fafc; color: #334155; border-radius: 10px; padding: 10px 12px; line-height: 1.5; white-space: pre-wrap;
`;

const SmallScore = styled.div`
  width: 46px; min-height: 42px; display: inline-flex; align-items: center; justify-content: center; border-radius: 10px; border: 1px solid #dbe3ee; background: ${(props) => (props.muted ? "#f8fafc" : "#eef2ff")}; font-weight: 800; color: #0f172a;
`;

const ScoreList = styled.div`
  display: grid; gap: 10px;
`;

const EditableScore = styled.input`
  width: 100%; max-width: 60px; padding: 6px 4px; text-align: center; border: 1px solid #2563eb; border-radius: 8px; font-weight: 700; font-size: 14px; outline: none;
`;

const EditableText = styled.textarea`
  width: 100%; min-height: 72px; border: 1px solid #2563eb; border-radius: 10px; padding: 10px 12px; font-size: 13px; resize: vertical; outline: none;
`;

const LegacyTable = styled.table`
  width: 100%; min-width: 1200px; border-collapse: collapse;
  th, td { border-bottom: 1px solid #e5e7eb; vertical-align: top; padding: 12px; text-align: left; font-size: 14px; }
  thead th { background: #f8fafc; color: #0f172a; font-weight: 800; white-space: nowrap; }
`;

const SummaryGrid = styled.div`
  display: grid; grid-template-columns: 1fr 1fr; gap: 18px;
  @media (max-width: 980px) { grid-template-columns: 1fr; }
`;

const SummaryCard = styled.div`
  border: 1px solid #e5e7eb; border-radius: 16px; padding: 24px; background: white;
  display: flex; flex-direction: column; justify-content: center;
`;

const CardTitle = styled.h4`
  margin: 0 0 16px; font-size: 1.1rem; font-weight: 800; color: #0f172a;
`;

const ScoreRow = styled.div`
  display: flex; justify-content: space-between; align-items: center; gap: 12px; padding: 14px 18px;
  border-radius: 12px; background: ${({ variant }) => variant === 'supervisor' ? '#f0fdf4' : '#eff6ff'};
  border: 1px solid ${({ variant }) => variant === 'supervisor' ? '#bbf7d0' : '#bfdbfe'};
  font-size: 14px; font-weight: 700; color: ${({ variant }) => variant === 'supervisor' ? '#166534' : '#1e40af'};
`;

const BigGrade = styled.div`
  font-size: clamp(2.5rem, 2rem + 1vw, 3.5rem); font-weight: 900; color: #1d4ed8; margin-top: 10px;
`;

const TextBlock = styled.div`
  min-height: 110px; border: 1px solid #e2e8f0; border-radius: 14px; background: #f8fafc; padding: 16px; white-space: pre-wrap; line-height: 1.7; color: #334155;
`;

const SaveButton = styled.button`
  background: linear-gradient(135deg, #16a34a, #22c55e); color: white; border: none; padding: 16px 32px; border-radius: 16px; font-weight: 800; font-size: 1.1rem; cursor: pointer; margin: 30px 0 10px; transition: all 0.2s; width: 100%;
  &:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 10px 20px rgba(22, 163, 74, 0.3); }
  &:disabled { background: #94a3b8; cursor: not-allowed; }
`;

const InfoMessage = styled.div`
  text-align: center; padding: 90px 20px; color: #64748b; background: white; border-radius: 20px; border: 1px dashed #cbd5e1;
`;

/* ================= MAIN COMPONENT ================= */
const SupervisorAppraisalForm = ({ user }) => {
  const [collapsed, setCollapsed] = useState(false);
  const { appraisalId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [appraisal, setAppraisal] = useState(null);
  const [goals, setGoals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState("");

  const [editedData, setEditedData] = useState({
    section2: [],
    section3: [],
    section4: [],
    summary: {},
    staffFeedback: {},
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        // 1. Fetch the appraisal
        const appRes = await api.get(`/appraisal/${appraisalId}`);
        const appraisalData = appRes.data?.appraisal || appRes.data?.data || appRes.data || {};
        
        // 2. Identify the Staff ID
        let staffId = location.state?.staffId;
        if (!staffId) {
            let rawStaffId = appraisalData.userId || appraisalData.userDetails || appraisalData.user || appraisalData.staffId;
            if (rawStaffId) {
                if (typeof rawStaffId === "string") {
                    staffId = rawStaffId;
                } else if (typeof rawStaffId === "object") {
                    staffId = rawStaffId._id || rawStaffId.id || rawStaffId.$oid || "";
                }
            }
        }
        staffId = String(staffId).trim();

        if (!staffId || staffId === "[object Object]" || staffId === "undefined") {
            console.error("CRITICAL ERROR: Could not find the Staff ID! Raw data:", appraisalData);
            throw new Error("Cannot load goals: Staff ID is missing.");
        }

        // 🔥 FIX: Extract the appraisal period and format it to YYYY-MM for the dynamic goal fetcher
        const periodStr = appraisalData.appraisalPeriod; // e.g. "April 2026"
        const targetMonthParam = formatToYearMonth(periodStr);

        // 3. Fetch goals dynamically for that specific month!
        const goalsRes = await api.get(`/goals/staff-month-goals/${staffId}?targetMonth=${targetMonthParam}`);
        const currentGoals = goalsRes.data?.data || [];
        const responseMonth = goalsRes.data?.month || "";

        setAppraisal(appraisalData);
        setGoals(currentGoals);

        const mergedSection2 = buildMergedSection2(appraisalData, currentGoals, responseMonth);

        setEditedData({
          section2: mergedSection2,
          section3: appraisalData.section3 || [],
          section4: appraisalData.section4 || [],
          summary: appraisalData.summary || {},
          staffFeedback: appraisalData.staffFeedback || {},
        });
      } catch (err) {
        console.error(err);
        setError(err.response?.data?.message || err.message || "Failed to load data");
      } finally {
        setLoading(false);
      }
    };

    if (appraisalId) fetchData();
  }, [appraisalId, location.state]);

  const buildMergedSection2 = (appraisalData, currentGoals, responseMonth) => {
    const existingSection2 = appraisalData.section2 || [];
    const existingMonth = existingSection2[0] || {};

    const monthlyGoals = currentGoals.filter(g => g.type === "monthly");
    const routineGoals = currentGoals.filter(g => g.type === "routine");

    const majorGoals = monthlyGoals.map((liveGoal) => {
      const saved = existingSection2.flatMap(m => m.majorGoals || [])
        .find(s => String(s.goal) === String(liveGoal.goal) || String(s.goalId) === String(liveGoal._id)) || {};

      const liveWeeks = currentGoals
        .filter(w => w.type === "weekly" && String(w.parentMonthlyGoal) === String(liveGoal._id))
        .sort((a, b) => new Date(a.weeklyDeliveryDate || 0) - new Date(b.weeklyDeliveryDate || 0));
      
      let weekly = [];
      if (liveWeeks.length > 0) {
          weekly = liveWeeks.map((w) => ({
            week: getWeekOfMonth(w.weeklyDeliveryDate),
            weeklyGoal: w.goal || "",
            weeklyAchievement: w.achievements || "",
            weeklyComment: w.comments || "",
            weeklyDeliveryDate: w.weeklyDeliveryDate,
          }));
      } else if (saved.weekly && saved.weekly.length > 0) {
          weekly = saved.weekly;
      }

      return {
        goalId: liveGoal._id,
        goal: liveGoal.goal || "",
        unit: getGoalUnit(liveGoal),
        startDate: liveGoal.startDate,
        deliveryDate: liveGoal.deliveryDate,
        achievement: saved.achievement || liveGoal.monthlyAchievements || liveGoal.achievements || "",
        staffComment: saved.staffComment || liveGoal.monthlyComments || liveGoal.comments || saved.comments || "",
        staffActionScore: saved.staffActionScore ?? "",
        staffQualityScore: saved.staffQualityScore ?? "",
        supervisorActionScore: saved.supervisorActionScore ?? "",
        supervisorQualityScore: saved.supervisorQualityScore ?? "",
        supervisorComments: saved.supervisorComments || "",
        weekly,
      };
    });

    const otherGoals = routineGoals.map((liveGoal) => {
      const saved = existingSection2.flatMap(m => m.otherGoals || [])
        .find(s => String(s.goal) === String(liveGoal.goal) || String(s.goalId) === String(liveGoal._id)) || {};

      return {
        goalId: liveGoal._id,
        goal: liveGoal.goal || "",
        unit: getGoalUnit(liveGoal),
        deliveryDate: liveGoal.deliveryDate,
        achievement: saved.achievement || liveGoal.achievements || "",
        staffComment: saved.staffComment || liveGoal.comments || saved.comments || "",
        staffActionScore: saved.staffActionScore ?? "",
        staffQualityScore: saved.staffQualityScore ?? "",
        supervisorActionScore: saved.supervisorActionScore ?? "",
        supervisorQualityScore: saved.supervisorQualityScore ?? "",
        supervisorComments: saved.supervisorComments || "",
      };
    });

    return [{
      month: responseMonth || existingMonth.month || appraisalData.appraisalPeriod || "Current Month",
      majorGoals,
      otherGoals,
    }];
  };

  const monthData = useMemo(() => editedData.section2 || [], [editedData.section2]);

  /* ================= CALCULATIONS ================= */
  const section2SupervisorTotal = useMemo(() => {
    return (editedData.section2 || []).reduce((acc, month) => {
      const majorValid = (month.majorGoals || []).filter(g =>
        !isNaN(Number(g.supervisorActionScore)) && !isNaN(Number(g.supervisorQualityScore))
      );
      const otherValid = (month.otherGoals || []).filter(g =>
        !isNaN(Number(g.supervisorActionScore)) && !isNaN(Number(g.supervisorQualityScore))
      );

      const majorSum = majorValid.reduce((sum, g) =>
        sum + ((Number(g.supervisorActionScore) + Number(g.supervisorQualityScore)) / 2), 0
      );
      const otherSum = otherValid.reduce((sum, g) =>
        sum + ((Number(g.supervisorActionScore) + Number(g.supervisorQualityScore)) / 2), 0
      );

      const majorTotal = majorValid.length ? ((majorSum / majorValid.length) / 5) * 55 : 0;
      const otherTotal = otherValid.length ? ((otherSum / otherValid.length) / 5) * 15 : 0;

      return acc + majorTotal + otherTotal;
    }, 0);
  }, [editedData.section2]);

  const section3SupervisorTotal = useMemo(() => {
    const items = editedData.section3 || [];
    const valid = items.filter(x => !isNaN(Number(x.supervisorScore)));
    const sum = valid.reduce((acc, item) => acc + Number(item.supervisorScore), 0);
    return valid.length ? (sum / valid.length / 5) * 20 : 0;
  }, [editedData.section3]);

  const section4SupervisorTotal = useMemo(() => {
    const items = editedData.section4 || [];
    const valid = items.filter(x => !isNaN(Number(x.supervisorScore)));
    const sum = valid.reduce((acc, item) => acc + Number(item.supervisorScore), 0);
    return valid.length ? (sum / valid.length / 5) * 10 : 0;
  }, [editedData.section4]);

  const computedSupervisorCumulative = useMemo(() => {
    return section2SupervisorTotal + section3SupervisorTotal + section4SupervisorTotal;
  }, [section2SupervisorTotal, section3SupervisorTotal, section4SupervisorTotal]);

  useEffect(() => {
    setEditedData((prev) => ({
      ...prev,
      summary: {
        ...prev.summary,
        supervisorCumulative: Number(computedSupervisorCumulative.toFixed(2)),
        supervisorGrade: gradeFromScore(computedSupervisorCumulative),
      },
    }));
  }, [computedSupervisorCumulative]);

  /* ================= HANDLERS ================= */
  const handleSection2Change = (monthIndex, goalType, goalIndex, field, value) => {
    setEditedData((prev) => {
      const next = [...prev.section2];
      const month = { ...next[monthIndex] };
      const goalsList = [...(month[goalType] || [])];
      goalsList[goalIndex] = { ...goalsList[goalIndex], [field]: value };
      month[goalType] = goalsList;
      next[monthIndex] = month;
      return { ...prev, section2: next };
    });
  };

  const handleSectionChange = (section, index, field, value) => {
    setEditedData((prev) => {
      const next = [...(prev[section] || [])];
      next[index] = { ...next[index], [field]: value };
      return { ...prev, [section]: next };
    });
  };

  const handleSummaryChange = (field, value) => {
    setEditedData((prev) => ({
      ...prev,
      summary: { ...prev.summary, [field]: value },
    }));
  };

  const handleOverallCommentsChange = (value) => {
    setEditedData((prev) => ({
      ...prev,
      staffFeedback: { ...prev.staffFeedback, supervisorAttention: value },
    }));
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      setError(null);
      setSuccess("");

      await api.put(`/appraisal/supervisor-score/${appraisalId}`, {
        section2: editedData.section2,
        section3: editedData.section3,
        section4: editedData.section4,
        summary: {
          supervisorCumulative: editedData.summary.supervisorCumulative,
          supervisorGrade: editedData.summary.supervisorGrade,
          supervisorOverallComments: editedData.summary.supervisorOverallComments || "",
        },
        staffFeedback: editedData.staffFeedback,
      });

      setSuccess("Appraisal updated successfully!");
      setTimeout(() => navigate("/supervisor/dashboard"), 1500);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Failed to save changes");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <Container $collapsed={collapsed}><NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} /><Main><InfoMessage>Loading appraisal...</InfoMessage></Main><Footer /></Container>;
  if (error) return <Container $collapsed={collapsed}><NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} /><Main><InfoMessage style={{ color: "red" }}>Error: {error}</InfoMessage></Main><Footer /></Container>;
  if (!appraisal) return <Container $collapsed={collapsed}><NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} /><Main><InfoMessage>Appraisal not found</InfoMessage></Main><Footer /></Container>;

  return (
    <Container $collapsed={collapsed}>
      <NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} />

      <Main>
        <PageHeader>
          <div>
            <Title>Supervisor's Assessment</Title>
            <Subtitle>
              Review full appraisal for {appraisal.userDetails?.username || "Staff"} — only supervisor fields are editable
            </Subtitle>
          </div>
        </PageHeader>

        <DocumentCard>
          <DocumentTop>
            <DocTitle>{appraisal.userDetails?.username || "Staff"}</DocTitle>
            <PeriodRow>
              <Pill>{appraisal.appraisalPeriod}</Pill>
            </PeriodRow>
          </DocumentTop>

          {/* =======================================================
              SECTION 2: PERFORMANCE ON GOALS
              ======================================================= */}
          <SectionBlock>
            <SectionHeading>
              <SectionTitle>PERFORMANCE ON GOALS</SectionTitle>
            </SectionHeading>

            {monthData.map((monthEntry, mIndex) => (
              <div key={mIndex} style={{ marginBottom: "48px" }}>
                <SectionTitle style={{ marginBottom: 16, fontSize: "21px", color: "#1e40af" }}>
                  Performance for {formatValue(monthEntry.month)}
                </SectionTitle>

                {/* --- MAJOR GOALS TABLE --- */}
                <SectionHeader>
                  <SecTitle>Major Goals</SecTitle>
                </SectionHeader>

                <TableWrapper>
                  <Table>
                    <thead>
                      <tr>
                        <Th style={{ width: "20%" }}>Goals</Th>
                        <Th style={{ width: "22%" }}>Achievements</Th>
                        <Th style={{ width: "7%" }}>STAFF SCORE ON ACTIONS (0-5)</Th>
                        <Th style={{ width: "7%" }}>STAFF SCORE ON QUALITY (0-5) </Th>
                        <Th style={{ width: "8%" }}>SUPERVISOR'S SCORE ON ACTION TAKEN<br></br>(0-5)</Th>
                        <Th style={{ width: "8%" }}>SUPERVISOR'S SCORE ON QUALITY OF DELIVERY<br></br>(0-5)</Th>
                        <Th style={{ width: "28%" }}>SUPERVISOR'S COMMENTS</Th>
                      </tr>
                    </thead>
                    <tbody>
                      {(monthEntry.majorGoals || []).map((goal, gIndex) => {
                        const weeks = goal.weekly || [];
                        const rowSpanCount = weeks.length > 0 ? weeks.length + 1 : 1;

                        return (
                          <React.Fragment key={goal.goalId || `major-${gIndex}`}>
                            <tr>
                              <Td style={rowSpanCount > 1 ? { borderBottom: "none", paddingBottom: "6px" } : {}}>
                                <MonthlyHeader>
                                  <ExpandableText text={goal.goal} limit={85} />
                                  {goal.unit && <UnitBadge style={{ marginTop: "6px" }}>{goal.unit}</UnitBadge>}
                                  <GoalDate>
                                    {formatNiceDate(goal.startDate)} - {formatNiceDate(goal.deliveryDate)}
                                  </GoalDate>
                                </MonthlyHeader>
                              </Td>

                              <Td style={rowSpanCount > 1 ? { borderBottom: "none", paddingBottom: "6px" } : {}}>
                                <DisabledInput style={{ minHeight: "90px", background: "#fff" }}>
                                  <strong>Monthly Achievement:</strong><br />
                                  <ExpandableText text={goal.achievement || "No monthly achievement submitted."} limit={120} />
                                </DisabledInput>
                              </Td>

                              <Td rowSpan={rowSpanCount}><SmallScore>{scoreValue(goal.staffActionScore)}</SmallScore></Td>
                              <Td rowSpan={rowSpanCount}><SmallScore>{scoreValue(goal.staffQualityScore)}</SmallScore></Td>

                              <Td rowSpan={rowSpanCount}>
                                <EditableScore
                                  type="number" min="0" max="5" step="0.1"
                                  value={goal.supervisorActionScore ?? ""}
                                  onChange={(e) => handleSection2Change(mIndex, "majorGoals", gIndex, "supervisorActionScore", e.target.value)}
                                />
                              </Td>
                              <Td rowSpan={rowSpanCount}>
                                <EditableScore
                                  type="number" min="0" max="5" step="0.1"
                                  value={goal.supervisorQualityScore ?? ""}
                                  onChange={(e) => handleSection2Change(mIndex, "majorGoals", gIndex, "supervisorQualityScore", e.target.value)}
                                />
                              </Td>

                              <Td rowSpan={rowSpanCount}>
                                <CommentLabel $color="#ef4444">Staff Comment</CommentLabel>
                                <DisabledInput style={{ background: "white", padding: "8px", minHeight: "40px" }}>
                                  {goal.staffComment || "No staff comment"}
                                </DisabledInput>

                                <CommentLabel $color="#0f172a" $marginTop="12px">Supervisor's Comment</CommentLabel>
                                <EditableText
                                  value={goal.supervisorComments || ""}
                                  onChange={(e) => handleSection2Change(mIndex, "majorGoals", gIndex, "supervisorComments", e.target.value)}
                                  placeholder="Enter supervisor comment..."
                                />
                              </Td>
                            </tr>

                            {/* WEEKLY ROWS */}
                            {weeks.map((week, index) => {
                              const isLast = index === weeks.length - 1;
                              const cellStyle = {
                                borderBottom: isLast ? undefined : "none",
                                borderRight: "1px solid #e2e8f0", 
                                paddingTop: "6px", paddingBottom: isLast ? undefined : "6px"
                              };
                              const wWeek = week.week || `Week ${index + 1}`;
                              
                              return (
                                <tr key={`week-${index}`}>
                                  <Td style={cellStyle}>
                                    <WeekGoalBox>
                                      <strong>{wWeek} Goal</strong>
                                      <div style={{ marginTop: "6px" }}>
                                        <ExpandableText text={week.weeklyGoal || week.goal} limit={70} isWeekly={true} />
                                      </div>
                                    </WeekGoalBox>
                                  </Td>
                                  <Td style={cellStyle}>
                                    <WeekAchBox>
                                      <strong>{wWeek} Achievement</strong>
                                      <div style={{ marginTop: "6px" }}>
                                        {(week.weeklyAchievement || week.achievements)?.trim() 
                                          ? (week.weeklyAchievement || week.achievements) 
                                          : "No achievement submitted."}
                                      </div>
                                    </WeekAchBox>
                                  </Td>
                                </tr>
                              );
                            })}
                          </React.Fragment>
                        );
                      })}
                    </tbody>
                  </Table>
                </TableWrapper>

                {/* --- OTHER GOALS TABLE --- */}
                <SectionHeader>
                  <SecTitle>Other Goals</SecTitle>
                </SectionHeader>

                <TableWrapper>
                  <Table>
                    <thead>
                      <tr>
                        <Th style={{ width: "20%" }}>Goals</Th>
                        <Th style={{ width: "22%" }}>Achievements</Th>
                        <Th style={{ width: "7%" }}>STAFF SCORE ON ACTIONS (0-5)</Th>
                        <Th style={{ width: "7%" }}>STAFF SCORE ON QUALITY (0-5)</Th>
                        <Th style={{ width: "8%" }}>SUPERVISOR'S SCORE ON ACTION TAKEN<br></br>(0-5)</Th>
                        <Th style={{ width: "8%" }}>SUPERVISOR'S SCORE ON QUALITY OF DELIVERY<br></br>(0-5)</Th>
                        <Th style={{ width: "28%" }}>SUPERVISOR'S COMMENTS</Th>
                      </tr>
                    </thead>
                    <tbody>
                      {(monthEntry.otherGoals || []).map((goal, gIndex) => (
                        <tr key={goal.goalId || `other-${gIndex}`}>
                          <Td>
                            <RoutineHeader>
                              <ExpandableText text={goal.goal} limit={85} />
                              {goal.unit && <UnitBadge>{goal.unit}</UnitBadge>}
                              <GoalDate>Due {formatNiceDate(goal.deliveryDate)}</GoalDate>
                            </RoutineHeader>
                          </Td>
                          <Td>
                            <DisabledInput style={{ background: "#fff" }}>
                               <ExpandableText text={goal.achievement || "No achievement submitted."} limit={120} />
                            </DisabledInput>
                          </Td>
                          <Td><SmallScore>{scoreValue(goal.staffActionScore)}</SmallScore></Td>
                          <Td><SmallScore>{scoreValue(goal.staffQualityScore)}</SmallScore></Td>
                          <Td>
                            <EditableScore
                              type="number" min="0" max="5" step="0.1"
                              value={goal.supervisorActionScore ?? ""}
                              onChange={(e) => handleSection2Change(mIndex, "otherGoals", gIndex, "supervisorActionScore", e.target.value)}
                            />
                          </Td>
                          <Td>
                            <EditableScore
                              type="number" min="0" max="5" step="0.1"
                              value={goal.supervisorQualityScore ?? ""}
                              onChange={(e) => handleSection2Change(mIndex, "otherGoals", gIndex, "supervisorQualityScore", e.target.value)}
                            />
                          </Td>
                          <Td>
                            <CommentLabel $color="#ef4444">Staff Comment</CommentLabel>
                            <DisabledInput style={{ background: "white", padding: "8px", minHeight: "40px" }}>
                              {goal.staffComment || "No staff comment"}
                            </DisabledInput>

                            <CommentLabel $color="#0f172a" $marginTop="12px">Supervisor's Comment</CommentLabel>
                            <EditableText
                              value={goal.supervisorComments || ""}
                              onChange={(e) => handleSection2Change(mIndex, "otherGoals", gIndex, "supervisorComments", e.target.value)}
                              placeholder="Enter supervisor comment..."
                            />
                          </Td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </TableWrapper>

                {/* --- MOBILE VIEW --- */}
                <MobileGrid>
                   {(monthEntry.majorGoals || []).map((goal, gIndex) => {
                     const weeks = goal.weekly || [];
                     return (
                       <MobileCard key={goal.goalId || `mob-major-${gIndex}`} $isRoutine={false}>
                          <MobileTop>
                            <MobilePill $isRoutine={false}>Major Goal</MobilePill>
                          </MobileTop>
                          <div style={{fontWeight: "800", color: "#0f172a", marginBottom: "4px", fontSize: "14px"}}>
                            <ExpandableText text={goal.goal} limit={90} />
                          </div>
                          <MobileDate>{formatNiceDate(goal.startDate)} - {formatNiceDate(goal.deliveryDate)}</MobileDate>

                          <MobileLabel>Monthly Achievement</MobileLabel>
                          <DisabledInput style={{ background: "#fff", marginBottom: "12px" }}>
                            {goal.achievement || "No monthly achievement submitted."}
                          </DisabledInput>

                          {/* Mobile Weekly Goals */}
                          {weeks.length > 0 && (
                            <div style={{ marginTop: "12px", display: "flex", flexDirection: "column", gap: "10px", marginBottom: "16px" }}>
                              {weeks.map((w, wIdx) => {
                                const wWeek = w.week || `Week ${wIdx + 1}`;
                                return (
                                  <div key={wIdx} style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px", border: "1px solid #e2e8f0" }}>
                                    <div style={{ color: "#ef4444", fontWeight: "700", fontSize: "12px" }}>{wWeek} Goal</div>
                                    <div style={{ fontSize: "13px", marginTop: "4px" }}>{w.weeklyGoal || w.goal}</div>
                                    <div style={{ color: "#16a34a", fontWeight: "700", fontSize: "12px", marginTop: "10px" }}>{wWeek} Achievement</div>
                                    <div style={{ fontSize: "13px", marginTop: "4px" }}>{(w.weeklyAchievement || w.achievements) || "None"}</div>
                                  </div>
                                )
                              })}
                            </div>
                          )}

                          <MobileLabel>Staff Scores</MobileLabel>
                          <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
                            <SmallScore>A: {scoreValue(goal.staffActionScore)}</SmallScore>
                            <SmallScore>Q: {scoreValue(goal.staffQualityScore)}</SmallScore>
                          </div>

                          <MobileLabel>Staff Comment</MobileLabel>
                          <DisabledInput style={{ marginBottom: "10px", background: "white" }}>
                            {goal.staffComment || "No comment."}
                          </DisabledInput>

                          <MobileLabel>Supervisor Action Score</MobileLabel>
                          <EditableScore type="number" min="0" max="5" step="0.1" value={goal.supervisorActionScore ?? ""} onChange={(e) => handleSection2Change(mIndex, "majorGoals", gIndex, "supervisorActionScore", e.target.value)} />
                          
                          <MobileLabel>Supervisor Quality Score</MobileLabel>
                          <EditableScore type="number" min="0" max="5" step="0.1" value={goal.supervisorQualityScore ?? ""} onChange={(e) => handleSection2Change(mIndex, "majorGoals", gIndex, "supervisorQualityScore", e.target.value)} />
                          
                          <MobileLabel>Supervisor Comment</MobileLabel>
                          <EditableText value={goal.supervisorComments || ""} onChange={(e) => handleSection2Change(mIndex, "majorGoals", gIndex, "supervisorComments", e.target.value)} />
                       </MobileCard>
                     )
                   })}

                   {(monthEntry.otherGoals || []).map((goal, gIndex) => (
                     <MobileCard key={goal.goalId || `mob-other-${gIndex}`} $isRoutine={true}>
                          <MobileTop>
                            <MobilePill $isRoutine={true}>Other Goal</MobilePill>
                          </MobileTop>
                          <div style={{fontWeight: "800", color: "#0f172a", marginBottom: "4px", fontSize: "14px"}}>
                            <ExpandableText text={goal.goal} limit={90} />
                          </div>
                          <MobileDate>Due {formatNiceDate(goal.deliveryDate)}</MobileDate>

                          <MobileLabel>Achievement</MobileLabel>
                          <DisabledInput style={{ background: "#fff", marginBottom: "12px" }}>
                            {goal.achievement || "No achievement submitted."}
                          </DisabledInput>

                          <MobileLabel>Staff Scores</MobileLabel>
                          <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
                            <SmallScore>A: {scoreValue(goal.staffActionScore)}</SmallScore>
                            <SmallScore>Q: {scoreValue(goal.staffQualityScore)}</SmallScore>
                          </div>

                          <MobileLabel>Staff Comment</MobileLabel>
                          <DisabledInput style={{ marginBottom: "10px", background: "white" }}>
                            {goal.staffComment || "No comment."}
                          </DisabledInput>

                          <MobileLabel>Supervisor Action Score</MobileLabel>
                          <EditableScore type="number" min="0" max="5" step="0.1" value={goal.supervisorActionScore ?? ""} onChange={(e) => handleSection2Change(mIndex, "otherGoals", gIndex, "supervisorActionScore", e.target.value)} />
                          
                          <MobileLabel>Supervisor Quality Score</MobileLabel>
                          <EditableScore type="number" min="0" max="5" step="0.1" value={goal.supervisorQualityScore ?? ""} onChange={(e) => handleSection2Change(mIndex, "otherGoals", gIndex, "supervisorQualityScore", e.target.value)} />
                          
                          <MobileLabel>Supervisor Comment</MobileLabel>
                          <EditableText value={goal.supervisorComments || ""} onChange={(e) => handleSection2Change(mIndex, "otherGoals", gIndex, "supervisorComments", e.target.value)} />
                       </MobileCard>
                   ))}
                </MobileGrid>
              </div>
            ))}
          </SectionBlock>

          <SectionBlock>
            <SectionHeading>
              <SectionTitle>WORK ETHIC & LEADERSHIP</SectionTitle>
              <SectionSub>Staff scores remain visible, supervisor scores editable</SectionSub>
            </SectionHeading>
            <TableWrap>
              <LegacyTable>
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>ATTRIBUTE</th>
                    <th>DESCRIPTION</th>
                    <th>STAFF SCORE</th>
                    <th>STAFF COMMENTS</th>
                    <th>SUPERVISOR'S
                    SCORE</th>
                    <th>SUPERVISOR'S COMMENTS</th>
                  </tr>
                </thead>
                <tbody>
                  {(editedData.section3 || []).map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td><DisabledInput>{formatValue(item.attribute)}</DisabledInput></td>
                      <td><DisabledInput>{formatValue(item.description)}</DisabledInput></td>
                      <td><SmallScore>{scoreValue(item.staffScore)}</SmallScore></td>
                      <td><DisabledInput>{formatValue(item.staffComments)}</DisabledInput></td>
                      <td>
                        <EditableScore
                          type="number" min="0" max="5" step="0.1"
                          value={item.supervisorScore ?? ""}
                          onChange={(e) => handleSectionChange("section3", index, "supervisorScore", e.target.value)}
                        />
                      </td>
                      <td>
                        <EditableText
                          value={item.supervisorComments || ""}
                          onChange={(e) => handleSectionChange("section3", index, "supervisorComments", e.target.value)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </LegacyTable>
            </TableWrap>
          </SectionBlock>

          <SectionBlock>
            <SectionHeading>
              <SectionTitle>COMPLIANCE</SectionTitle>
              <SectionSub>Staff scores remain visible, supervisor scores editable</SectionSub>
            </SectionHeading>
            <TableWrap>
              <LegacyTable>
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>PROTOCOL</th>
                    <th>DESCRIPTION</th>
                    <th>STAFF SCORE</th>
                    <th>STAFF COMMENTS</th>
                    <th>SUPERVISOR'S SCORE</th>
                    <th>SUPERVISOR'S COMMENTS</th>
                  </tr>
                </thead>
                <tbody>
                  {(editedData.section4 || []).map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td><DisabledInput>{formatValue(item.attribute)}</DisabledInput></td>
                      <td><DisabledInput>{formatValue(item.description)}</DisabledInput></td>
                      <td><SmallScore>{scoreValue(item.staffScore)}</SmallScore></td>
                      <td><DisabledInput>{formatValue(item.staffComments)}</DisabledInput></td>
                      <td>
                        <EditableScore
                          type="number" min="0" max="5" step="0.1"
                          value={item.supervisorScore ?? ""}
                          onChange={(e) => handleSectionChange("section4", index, "supervisorScore", e.target.value)}
                        />
                      </td>
                      <td>
                        <EditableText
                          value={item.supervisorComments || ""}
                          onChange={(e) => handleSectionChange("section4", index, "supervisorComments", e.target.value)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </LegacyTable>
            </TableWrap>
          </SectionBlock>

          {/* =======================================================
              SUMMARY OF PERFORMANCE (SIDE-BY-SIDE REDESIGN)
              ======================================================= */}
          <SectionBlock>
            <SectionHeading>
              <SectionTitle>SUMMARY OF PERFORMANCE</SectionTitle>
              <SectionSub>Staff summary remains visible, supervisor summary auto-calculates</SectionSub>
            </SectionHeading>

            {/* Citation full width */}
            <SummaryCard style={{ marginBottom: "24px" }}>
              <CardTitle>500 Character Citation</CardTitle>
              <TextBlock>{formatValue(editedData.summary?.citation)}</TextBlock>
            </SummaryCard>

            <SummaryGrid>
              {/* --- LEFT COLUMN: STAFF TOTALS --- */}
              <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
                <SummaryCard>
                  <CardTitle>Staff Score Breakdown</CardTitle>
                  <ScoreList>
                    <ScoreRow variant="staff">
                      <span>Goals</span>
                      <strong>{formatValue(editedData.summary?.section2, 0)}</strong>
                    </ScoreRow>
                    <ScoreRow variant="staff">
                      <span>Ethics</span>
                      <strong>{formatValue(editedData.summary?.section3, 0)}</strong>
                    </ScoreRow>
                    <ScoreRow variant="staff">
                      <span>Compliance</span>
                      <strong>{formatValue(editedData.summary?.section4, 0)}</strong>
                    </ScoreRow>
                    <ScoreRow variant="staff" style={{ borderTop: "2px solid #bfdbfe", paddingTop: "14px", marginTop: "6px" }}>
                      <span>Staff Cumulative</span>
                      <strong style={{ fontSize: "1.1rem" }}>{formatValue(editedData.summary?.cumulative, 0)}</strong>
                    </ScoreRow>
                  </ScoreList>
                </SummaryCard>
                <SummaryCard style={{ alignItems: "center", textAlign: "center" }}>
                  <div style={{ fontSize: 13, fontWeight: 800, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "8px" }}>Staff Grade</div>
                  <BigGrade>{formatValue(editedData.summary?.grade, "—")}</BigGrade>
                </SummaryCard>
              </div>

              {/* --- RIGHT COLUMN: SUPERVISOR TOTALS --- */}
              <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
                <SummaryCard>
                  <CardTitle>Supervisor Score Breakdown</CardTitle>
                  <ScoreList>
                    <ScoreRow variant="supervisor">
                      <span>Goals</span>
                      <strong>{Number(section2SupervisorTotal || 0).toFixed(1)}</strong>
                    </ScoreRow>
                    <ScoreRow variant="supervisor">
                      <span>Ethics</span>
                      <strong>{Number(section3SupervisorTotal || 0).toFixed(1)}</strong>
                    </ScoreRow>
                    <ScoreRow variant="supervisor">
                      <span>Compliance</span>
                      <strong>{Number(section4SupervisorTotal || 0).toFixed(1)}</strong>
                    </ScoreRow>
                    <ScoreRow variant="supervisor" style={{ borderTop: "2px solid #bbf7d0", paddingTop: "14px", marginTop: "6px" }}>
                      <span>Supervisor Cumulative</span>
                      <strong style={{ fontSize: "1.1rem" }}>{Number(computedSupervisorCumulative || 0).toFixed(1)}</strong>
                    </ScoreRow>
                  </ScoreList>
                </SummaryCard>
                <SummaryCard style={{ alignItems: "center", textAlign: "center" }}>
                  <div style={{ fontSize: 13, fontWeight: 800, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "8px" }}>Supervisor Grade</div>
                  <BigGrade style={{ color: "#0f766e" }}>{gradeFromScore(computedSupervisorCumulative)}</BigGrade>
                </SummaryCard>
              </div>
            </SummaryGrid>
            
            <div style={{ display: "none" }}>
              <EditableScore
                type="number"
                value={editedData.summary?.supervisorCumulative ?? ""}
                onChange={(e) => handleSummaryChange("supervisorCumulative", e.target.value)}
              />
              <EditableText
                value={editedData.summary?.supervisorGrade || ""}
                onChange={(e) => handleSummaryChange("supervisorGrade", e.target.value)}
              />
            </div>
          </SectionBlock>

          <SectionBlock>
            <SectionHeading>
              <SectionTitle>SUPERVISOR’S OVERALL COMMENTS</SectionTitle>
              <SectionSub>Editable by supervisor</SectionSub>
            </SectionHeading>
            <EditableText
              style={{ minHeight: "120px" }}
              value={editedData.staffFeedback?.supervisorAttention || ""}
              onChange={(e) => handleOverallCommentsChange(e.target.value)}
              placeholder="Enter your final overall comments and feedback here..."
            />
          </SectionBlock>

          <SectionBlock>
            <SectionHeading>
              <SectionTitle>HEAD OF DEPARTMENT’S OVERALL COMMENTS</SectionTitle>
              <SectionSub>Read only for now</SectionSub>
            </SectionHeading>
            <TextBlock>{formatValue(editedData.summary?.hodOverallComments)}</TextBlock>
          </SectionBlock>

          <SaveButton onClick={handleSave} disabled={saving}>
            {saving ? "Saving Changes..." : "Save Supervisor Assessment"}
          </SaveButton>

          {success && <p style={{ color: "green", fontWeight: 600 }}>{success}</p>}
          {error && <p style={{ color: "red", fontWeight: 600 }}>{error}</p>}
        </DocumentCard>
      </Main>
      <Footer />
    </Container>
  );
};

export default SupervisorAppraisalForm;